/* eslint-disable array-callback-return */
//@ts-nocheck
import React from "react";
import "./style.css";
import "./chat-pop.css";
import "./chat-emb.css";
import "./chat-mod.css";
import { useSelector } from "react-redux";
import { ReduxDataKey } from "src/base/store/store";
import { Layout } from "src/base/store/layoutSlice";

export function RenderReactChatInstance({
  chatChannelId,
  tenantId,
  tenantApiBaseURL,
  assetsBaseUrl,
  domainBaseURL,
  pusherCluster,
  pusherClient,
  managerLocale,
  sufixGUID,
  modules,
  chatDataSetter,
  setChatDataSetter,
  setChatDataPreview,
}) {
  console.log("modules >>> ", modules);

  let widthValue;
  let widthIframeValue;
  function handleResize() {
    // Get the width of the parent window from the iframe
    widthValue = window.parent.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    widthIframeValue = window.innerWidth;
  }

  // Attach the handleResize function to the resize event of the parent window
  window.parent?.addEventListener("resize", handleResize);
  window?.addEventListener("resize", handleResize);

  // Call the handleResize function once to get the initial width
  handleResize();

  const mainStyle = {
    color: "#696969",
    fontFamily: "Inter, sans-serif",
  };

  const styles = {
    containerInput: Object.assign(
      {
        padding: 10,
        margin: 5,
        borderRadius: 10,
        flexDirection: "column",
        display: "flex",
        background: "rgba(255, 255, 255, 0.2)",
        boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
        backdropFilter: "blur(5px)",
        WebkitBackdropFilter: "blur(5px)",
        border: "1px solid rgba(255, 255, 255, 0.3)",
      },
      mainStyle
    ),
    question: Object.assign({ wordBreak: "break-word" }, mainStyle),
    col: Object.assign({ display: "flex", flexDirection: "column" }, mainStyle),
    input: { height: 20, width: "auto", marginRight: 5 },
    row: Object.assign({ display: "flex", flexDirection: "row" }, mainStyle),
    form: Object.assign(
      {
        backgroundColor: "#fff",
        borderRadius: 10,
        width: "80%",
        marginRight: "20%",
      },
      mainStyle
    ),
  };

  function openInNewTab() {
    let url = `${domainBaseURL}/chat/new_tab/${chatChannelId}?assets=${assetsBaseUrl.replace("https://", "").replace("/", "")}&guid=${sufixGUID}`;
    window.open(url, "_blank");
  }

  function correctToTimeZone(datetimeString) {
    return datetimeString;
    // Parse the datetime string into a Luxon DateTime object
    //const datetime = luxon.DateTime.fromFormat(datetimeString, "yyyy-MM-dd HH:mm:ss", { zone: "UTC" });

    // Get the DateTime object in the local timezone
    //const localDatetime = datetime.setZone(luxon.DateTime.local().zoneName);

    // Return the corrected datetime in the format "YYYY-MM-DD HH:mm:ss"
    //return localDatetime.toFormat("yyyy-MM-dd HH:mm:ss");
  }

  const parseDate = (dateString) => {
    return new Date(dateString.replace(" ", "T") + "Z");
  };

  function createObjectFromArray(array) {
    const result = {};
    for (const item of array) {
      result[item] = false;
    }
    return result;
  }

  function isTruthy(param) {
    return param === 1 || param === "1" || param === "on";
  }

  function delayedCallback(callback, delay) {
    if (Number(delay) < 0 || delay === "") {
      delay = 0;
    }

    let timeoutId;
    const resetTimeout = () => {
      clearTimeout(timeoutId);
    };

    const executeCallback = () => {
      callback();
      resetTimeout();
    };

    timeoutId = setTimeout(() => {
      executeCallback();
    }, Number(delay) * 1000);
  }

  function LoadingIcon() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        width="15"
        height="15"
        style={Object.assign({}, { shapeRendering: "auto", display: "block", background: "rgb(255, 255, 255)" })}
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g>
          <circle cx="50" cy="50" fill="none" stroke="#0c142d" strokeWidth="10" r="35" strokeDasharray="164.93361431346415 56.97787143782138">
            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1" />
          </circle>
          <g></g>
        </g>
        {/* [ldio] generated by https://loading.io */}
      </svg>
    );
  }

  function getFileExtension(filePath) {
    const lastDotIndex = filePath.lastIndexOf(".");

    if (lastDotIndex === -1) {
      return "";
    }

    const extension = filePath.slice(lastDotIndex + 1);

    return extension;
  }

  function renderLinks(text) {
    // Define the regular expression pattern to match both labeled links and plain links
    const pattern = /(?:\[([^\]]*)\]\(([^\)]*)\))|(?:(https?:\/\/[^\s]+))/g;

    // Use replace method with a callback function
    let result = [];
    let lastIndex = 0;
    text.replace(pattern, (match, label, link, plainLink, index) => {
      // Push the text before the match
      result.push(text.substring(lastIndex, index));
      // Push the link element if it's a labeled link
      if (label && link) {
        result.push(
          <a target="_blank" style={{ fontWeight: 600 }} href={link} key={match} rel="noreferrer">
            {label}
          </a>
        );
      }
      // Push the plain link element
      if (plainLink) {
        result.push(
          <a target="_blank" style={{ fontWeight: 600 }} href={plainLink} key={plainLink} rel="noreferrer">
            {plainLink}
          </a>
        );
      }
      // Update lastIndex
      lastIndex = index + match.length;
      return match;
    });
    // Push the remaining text after the last match
    result.push(text.substring(lastIndex));

    return result;
  }

  const renderBreakLines = (text) => {
    return (
      text?.split("\n")?.map((line, index) => {
        line = renderLinks(line);
        return index > 0 ? (
          <>
            <br />
            {line}
          </>
        ) : (
          line
        );
      }) ?? []
    );
  };

  function FormOpenCenteredButton({ src, title, setInvokedForm }) {
    const buttonStyle = {
      backgroundColor: "royalblue",
      border: "2px solid #fff", // You can customize the border styles
      color: "#fff", // You can customize the text color
      padding: "10px 20px", // You can customize the padding
      borderRadius: "5px", // You can customize the border-radius
      cursor: "pointer",
    };

    const containerStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "550px", // Adjust the height as needed
      width: "100%",
    };

    return (
      <div style={containerStyle}>
        <button
          onClick={() => {
            window.open(src, "_blank");
            if (window.localStorage.getItem("CHAINING_PHASE_" + sufixGUID)) {
              window.localStorage.removeItem("CHAINING_PHASE_" + sufixGUID);
            }
            setInvokedForm("");
          }}
          style={buttonStyle}
        >
          {title}
        </button>
      </div>
    );
  }

  const FormComponent = ({ src, title, width, height, lang, setInvokedForm }) => {
    return true ? (
      <iframe width="300" height="540" style={Object.assign({}, { borderRadius: 25 })} src={src} />
    ) : (
      <FormOpenCenteredButton title={`${lang("open_form")}`} src={src} setInvokedForm={setInvokedForm} />
    );
  };

  function UserAnswered({ lang, ask, answers }) {
    const corrects = Object.entries(answers)?.filter((ans) => ans[1] === true);

    return (
      <div style={Object.assign({}, { margin: 15 })}>
        <div
          style={Object.assign(
            {},
            {
              display: "flex",
              flexDirection: "column",
            }
          )}
        >
          <span>{ask}</span>
          <small>{lang("your_replies")}: </small>
        </div>
        {typeof answers === "string" ? (
          <ul style={Object.assign({}, { display: "flex", flexDirection: "row" })}>
            <li style={Object.assign({}, { fontWeight: 800 })}>{answers}</li>
          </ul>
        ) : (
          Object.entries(corrects).map((crt) => {
            return (
              <div style={Object.assign({}, { display: "flex", flexDirection: "row" })}>
                <ul style={Object.assign({}, { display: "flex", flexDirection: "row" })}>
                  <li style={Object.assign({}, { fontWeight: 800 })}>{crt[1]}</li>
                </ul>
              </div>
            );
          })
        )}
      </div>
    );
  }

  function Label({ children }) {
    return <label style={styles.question}>{children ?? "Input"}</label>;
  }

  function TextInput({ lang, optionId, saveAndEmitMessage }) {
    const [answer, setAnswer] = React.useState("");

    return (
      <div
        style={Object.assign(
          {},
          {
            marginTop: "5px",
            ...styles.col,
          }
        )}
      >
        <input
          onChange={({ target: { value } }) => setAnswer(value)}
          style={Object.assign(
            {},
            {
              width: "100%",
              background: "transparent",
              outline: "none",
              border: "none",
              borderBottom: "1px solid #696969",
              color: "#696969",
              padding: "10px",
            }
          )}
          type="text"
        />
        <button
          disabled={!answer.length}
          onClick={() => {
            if (!answer.length) {
              return;
            }
            saveAndEmitMessage(true, `option::${optionId}-["${answer}"]`);
          }}
          style={Object.assign(
            {},
            {
              marginTop: 5,
              marginBottom: 5,
              borderRadius: 10,
              backgroundColor: !!answer.length ? "#779dc9" : "#c9c9c9",
              width: "100%",
              height: "auto",
              minHeight: "40px",
              wordBreak: "break-word",
              color: "#ffffff",
              border: "none",
            }
          )}
        >
          {lang("send")}
        </button>
      </div>
    );
  }

  function RadioInput({ lang, optionId, values, saveAndEmitMessage }) {
    const [selectedOptions, setSelectedOptions] = React.useState(createObjectFromArray(values));
    const [isUnlocked, setIsUnlocked] = React.useState(false);

    const handleSelectChange = (event) => {
      const { value } = event.target;
      setSelectedOptions((s) => {
        return {
          ...createObjectFromArray(values),
          [value]: !selectedOptions[value],
        };
      });
    };

    React.useEffect(() => {
      setIsUnlocked(Object.values(selectedOptions).some((vl) => vl === true));
    }, [selectedOptions]);

    return (
      <div
        style={Object.assign(
          {},
          {
            marginTop: "5px",
            ...styles.col,
          }
        )}
      >
        {values?.map((v) => {
          return (
            <div
              style={Object.assign(
                {},
                {
                  marginTop: 5,
                  marginBottom: 5,
                  alignItems: "center",
                  display: "flex",
                }
              )}
            >
              <input name="radio-type" style={styles.input} key={v} type="radio" checked={selectedOptions[v]} value={v} onChange={handleSelectChange} />
              <label>{v}</label>
            </div>
          );
        })}
        <button
          disabled={!isUnlocked}
          onClick={() => {
            if (!isUnlocked) {
              return;
            }
            saveAndEmitMessage(true, `option::${optionId}-[${JSON.stringify(selectedOptions)}]`);
          }}
          style={Object.assign(
            {},
            {
              marginTop: 5,
              marginBottom: 5,
              borderRadius: 10,
              backgroundColor: isUnlocked ? "#779dc9" : "#c9c9c9",
              width: "100%",
              height: "auto",
              minHeight: "40px",
              wordBreak: "break-word",
              color: "#ffffff",
              border: "none",
            }
          )}
        >
          {lang("send")}
        </button>
      </div>
    );
  }

  function SelectInput({ lang, optionId, values, saveAndEmitMessage }) {
    const [selectedOptions, setSelectedOptions] = React.useState(createObjectFromArray(values));
    const [isUnlocked, setIsUnlocked] = React.useState(false);

    const handleSelectChange = (event) => {
      const { value } = event.target;
      setSelectedOptions((s) => {
        return {
          ...createObjectFromArray(values),
          [value]: !selectedOptions[value],
        };
      });
    };

    React.useEffect(() => {
      setIsUnlocked(Object.values(selectedOptions).some((vl) => vl === true));
    }, [selectedOptions]);

    return (
      <div
        style={Object.assign(
          {},
          {
            marginTop: "5px",
            ...styles.col,
          }
        )}
      >
        <select
          onChange={handleSelectChange}
          style={Object.assign(
            {},
            {
              padding: "5px",
              marginTop: "10px",
              borderRadius: "5px",
            }
          )}
        >
          <option selected disabled value={null}>
            {lang("select")}
          </option>
          {values?.map((v) => {
            return <option value={v}>{v}</option>;
          })}
        </select>
        <button
          disabled={!isUnlocked}
          onClick={() => {
            if (!isUnlocked) {
              return;
            }
            saveAndEmitMessage(true, `option::${optionId}-[${JSON.stringify(selectedOptions)}]`);
          }}
          style={Object.assign(
            {},
            {
              marginTop: 5,
              marginBottom: 5,
              borderRadius: 10,
              backgroundColor: isUnlocked ? "#779dc9" : "#c9c9c9",
              width: "100%",
              height: "auto",
              minHeight: "40px",
              wordBreak: "break-word",
              color: "#ffffff",
              border: "none",
            }
          )}
        >
          {lang("send")}
        </button>
      </div>
    );
  }

  function CheckboxInput({ lang, optionId, values, saveAndEmitMessage }) {
    const [checkboxes, setCheckboxes] = React.useState(createObjectFromArray(values));
    const [isUnlocked, setIsUnlocked] = React.useState(false);

    const handleCheckboxChange = (checkboxName) => {
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [checkboxName]: !prevCheckboxes[checkboxName],
      }));
    };

    React.useEffect(() => {
      setIsUnlocked(Object.values(checkboxes).some((vl) => vl === true));
    }, [checkboxes]);

    return (
      <div
        style={Object.assign(
          {},
          {
            marginTop: "5px",
            ...styles.col,
          }
        )}
      >
        {values?.map((v) => {
          return (
            <div
              style={Object.assign(
                {},
                {
                  marginTop: 5,
                  marginBottom: 5,
                  alignItems: "center",
                  display: "flex",
                }
              )}
            >
              <input type="checkbox" style={styles.input} value={v} id={v} name={v} onChange={() => handleCheckboxChange(v)} />
              <label for={v}>{v}</label>
            </div>
          );
        })}
        <button
          onClick={() => {
            if (!isUnlocked) {
              return;
            }
            saveAndEmitMessage(true, `option::${optionId}-[${JSON.stringify(checkboxes)}]`);
          }}
          disabled={!isUnlocked}
          style={Object.assign(
            {},
            {
              marginTop: 5,
              marginBottom: 5,
              borderRadius: 10,
              backgroundColor: isUnlocked ? "#779dc9" : "#c9c9c9",
              width: "100%",
              height: "auto",
              minHeight: "40px",
              wordBreak: "break-word",
              color: "#ffffff",
              border: "none",
            }
          )}
        >
          {lang("send")}
        </button>
      </div>
    );
  }

  function PickButtons({ optionId, values, saveAndEmitMessage, hasChainedOptionsActive }) {
    const [selectedOptions, setSelectedOptions] = React.useState(createObjectFromArray(values));
    const [isUnlocked, setIsUnlocked] = React.useState(true);

    const handleSelectChange = (value) => {
      let actualPhase = Number(window.localStorage.getItem("CHAINING_PHASE_" + sufixGUID));

      if (actualPhase) {
        actualPhase++;
        window.localStorage.setItem("CHAINING_PHASE_" + sufixGUID, String(actualPhase));
      }

      setSelectedOptions((s) => {
        return {
          ...createObjectFromArray(values),
          [value]: !selectedOptions[value],
        };
      });
    };

    React.useEffect(() => {
      const checkIfChoosen = Object.values(selectedOptions).some((vl) => vl === true);
      if (checkIfChoosen) {
        setIsUnlocked(checkIfChoosen);
        saveAndEmitMessage(true, `option::${optionId}-[${JSON.stringify(selectedOptions)}]`, hasChainedOptionsActive !== null ? false : true);
      }
    }, [selectedOptions]);

    return (
      <div
        style={Object.assign(
          {},
          {
            marginTop: "5px",
            ...styles.col,
          }
        )}
      >
        {values?.map((v) => {
          return (
            <button
              disabled={!isUnlocked}
              onClick={() => {
                handleSelectChange(v);
              }}
              style={Object.assign(
                {},
                {
                  marginTop: 5,
                  marginBottom: 5,
                  borderRadius: 10,
                  backgroundColor: "#779dc9",
                  width: "100%",
                  height: "auto",
                  minHeight: "40px",
                  wordBreak: "break-word",
                  color: "#ffffff",
                  border: "none",
                }
              )}
            >
              {v}
            </button>
          );
        })}
      </div>
    );
  }

  function pickRandomUtterance(stringUtts) {
    let parsedUttsArr = stringUtts.slice(2, stringUtts.length - 2).split("##,##");
    let randomIndex = Math.floor(Math.random() * parsedUttsArr.length);
    return parsedUttsArr[randomIndex];
  }

  function PickAiButtons({ flow, saveAndEmitMessage, message, customStyle, messagesData }) {
    const [stage, setStage] = React.useState(0);
    const [selectedOptions, setSelectedOptions] = React.useState([]);

    const handleSelectChange = (opt) => {
      setSelectedOptions((prevSelectedOptions) => [
        ...prevSelectedOptions,
        {
          q: flow[stage + 1],
          a: opt,
        },
      ]);

      if (stage > 0) {
        let contentAnswered = `{q: ${flow[stage + 1]?.data?.questions?.join(" ")}, a: ${opt.option}}`;
        if (!opt?.next || opt?.next?.length === 0) {
          if (window.FLOW_AI[sufixGUID]) {
            //End chained options with calling AI at end
            saveAndEmitMessage(false, "optionv2@ai::" + contentAnswered);
          } else {
            //End chained options without calling AI at end
            saveAndEmitMessage(false, "optionv2::" + contentAnswered);
          }
        } else {
          //Not end chained options yet
          saveAndEmitMessage(false, "optionv2::" + contentAnswered);
        }
      }

      if (stage < flow.length - 1) {
        setStage(stage + 1);
      }
    };

    return (
      <>
        {selectedOptions?.map((selected, idx) => {
          return (
            <div className="ebsss-widget-chat-msg ALREADY_SELECT" key={message?.id} style={idx === 0 ? Object.assign({}, { marginTop: 10 }) : {}}>
              <div className="ebsss-widget-chat-msg-profile">
                {customStyle?.hide_agent_image && customStyle?.hide_agent_image === "on" ? (
                  <></>
                ) : (
                  <img
                    className="ebsss-widget-chat-msg-img"
                    src="https://st4.depositphotos.com/4329009/19956/v/450/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
                    alt="Profile pic"
                  />
                )}
              </div>
              <div className="ebsss-widget-chat-msg-content">
                <div className="ebsss-widget-chat-msg-text" style={Object.assign({}, { color: "#000" })}>
                  <div style={Object.assign({}, { marginTop: "5px", ...styles.col })}>
                    <div style={Object.assign({}, { marginTop: "5px", ...styles.col })}>
                      <div style={Object.assign({}, { width: "100%" })}>
                        <span>{selected.q.data.questions[0]}</span>
                      </div>
                    </div>
                    <div style={Object.assign({}, { marginTop: "5px", gap: 5, flexWrap: "wrap", ...styles.row })}>
                      <button
                        style={Object.assign(
                          {},
                          {
                            marginTop: 5,
                            marginBottom: 5,
                            borderRadius: 10,
                            borderColor: "cornflowerblue",
                            borderWidth: 2,
                            height: "auto",
                            minHeight: "40px",
                            wordBreak: "break-word",
                            fontWeight: 600,
                            alignItems: "center",
                            display: "flex",
                          }
                        )}
                      >
                        <CheckIcon /> {selected.a.option}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {stage === flow.length - 1 ? (
          <></>
        ) : (
          <div
            className={`ebsss-widget-chat-msg TO_SELECT`}
            key={message?.id}
            style={messagesData.findIndex((ms) => ms.id === message?.id) === 0 ? Object.assign({}, { marginTop: 10 }) : {}}
          >
            <div className="ebsss-widget-chat-msg-profile">
              {customStyle?.hide_agent_image && customStyle?.hide_agent_image === "on" ? (
                <></>
              ) : (
                <img
                  className="ebsss-widget-chat-msg-img"
                  src="https://st4.depositphotos.com/4329009/19956/v/450/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
                  alt="Profile pic"
                />
              )}
            </div>
            <div className="ebsss-widget-chat-msg-content">
              <div className="ebsss-widget-chat-msg-text" style={Object.assign({}, { color: "#000" })}>
                <div style={Object.assign({}, { marginTop: "5px", ...styles.col })}>
                  <div style={Object.assign({}, { marginTop: "5px", ...styles.col })}>
                    {flow.slice(1, flow.length)[stage]?.data?.questions?.map((qst) => {
                      return (
                        <div key={JSON.stringify(qst)} style={Object.assign({}, { width: "100%" })}>
                          <span>{qst}</span>
                        </div>
                      );
                    })}
                  </div>
                  <div style={Object.assign({}, { marginTop: "5px", gap: 5, flexWrap: "wrap", ...styles.row })}>
                    {flow.slice(1, flow.length)[stage]?.data?.options?.map((option) => {
                      return (() => {
                        if (stage === 0) {
                          return (
                            <button
                              key={JSON.stringify(option)}
                              onClick={() => handleSelectChange(option)}
                              style={Object.assign(
                                {},
                                {
                                  marginTop: 5,
                                  marginBottom: 5,
                                  borderRadius: 10,
                                  borderColor: "cornflowerblue",
                                  borderWidth: 2,
                                  height: "auto",
                                  minHeight: "40px",
                                  wordBreak: "break-word",
                                  fontWeight: 600,
                                }
                              )}
                            >
                              {option.option}
                            </button>
                          );
                        }

                        if (selectedOptions[stage - 1]?.a?.next?.find((nxOp) => nxOp?.option === option?.id)) {
                          return (
                            <button
                              key={JSON.stringify(option)}
                              onClick={() => handleSelectChange(option)}
                              style={Object.assign(
                                {},
                                {
                                  marginTop: 5,
                                  marginBottom: 5,
                                  borderRadius: 10,
                                  borderColor: "cornflowerblue",
                                  borderWidth: 2,
                                  height: "auto",
                                  minHeight: "40px",
                                  wordBreak: "break-word",
                                  fontWeight: 600,
                                }
                              )}
                            >
                              {option.option}
                            </button>
                          );
                        }
                      })();
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  function ClientSupportReview({ saveAndEmitMessage, conversationToken, channelToken }) {
    const [rating, setRating] = React.useState(0);

    const handleStarClick = (value) => {
      setRating(value);
    };

    const starsStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    };

    const starStyle = {
      cursor: "pointer",
      fontSize: "24px",
      color: "#ccc",
      margin: "0 5px",
    };

    const activeStarStyle = {
      color: "#ffcc00",
    };

    const terminateChat = async () => {
      await apiWebsite.get(`/chat/end?conversation_token=${conversationToken}&channel=${channelToken}&uuid={{$tenant}}`);
    };

    React.useEffect(() => {
      if (rating > 0) {
        saveAndEmitMessage(false, `end::[${JSON.stringify({ rating: rating })}]`);
        setTimeout(() => {
          terminateChat();
        }, 2000);
      }
    }, [rating]);

    return (
      <div
        style={Object.assign(
          {},
          {
            textAlign: "center",
          }
        )}
      >
        <div style={starsStyle}>
          {[1, 2, 3, 4, 5].map((value) => (
            <span key={value} style={Object.assign({ ...starStyle }, { ...(value <= rating ? activeStarStyle : {}) })} onClick={() => handleStarClick(value)}>
              &#9733;
            </span>
          ))}
        </div>
      </div>
    );
  }

  function FormContainer({ formData, saveAndEmitMessage, conversationToken, channelToken, hasChainedOptionsActive, lang }) {
    function renderForm() {
      const renderable = {
        text: (props) => <TextInput {...props} />,
        radio: (props) => <RadioInput {...props} />,
        select: (props) => <SelectInput {...props} />,
        checkbox: (props) => <CheckboxInput {...props} />,
        pick: (props) => <PickButtons {...props} />,
        end: (props) => <ClientSupportReview {...props} />,
      };

      const prepareObjectElement = (formInput) => {
        let objElement = {
          hasChainedOptionsActive,
          saveAndEmitMessage,
        };

        if (formInput?.type === "end") {
          objElement.conversationToken = conversationToken;
          objElement.channelToken = channelToken;
        }

        return objElement;
      };

      return formData?.map((formInput) => {
        return (
          <div style={styles.containerInput}>
            <Label>{formInput?.type === "end" ? formInput.message : formInput.label}</Label>
            {renderable[formInput?.type]({
              ...prepareObjectElement(formInput),
              values: formInput?.values,
              optionId: formInput.id,
              lang,
            })}
          </div>
        );
      });
    }

    return (
      <form style={styles.form} onSubmit={(e) => e.preventDefault()}>
        {renderForm()}
      </form>
    );
  }

  const OptionComponent = ({ data, saveAndEmitMessage, hasChainedOptionsActive, channelToken, conversationToken, lang }) => {
    return (
      <FormContainer
        lang={lang}
        conversationToken={conversationToken}
        channelToken={channelToken}
        formData={data}
        saveAndEmitMessage={saveAndEmitMessage}
        hasChainedOptionsActive={hasChainedOptionsActive}
      />
    );
  };

  function handleElementString(
    message = "",
    lang,
    hasChainedOptionsActive = false,
    messagesData = [],
    renderNow = false,
    saveAndEmitMessage = false,
    conversationToken = "",
    channelToken = ""
  ) {
    //message = renderBreakLines(message).join()

    if (!message?.startsWith("[>") && !message?.endsWith("<]")) {
      return false;
    }

    const parsedData = JSON.parse(
      message
        ?.slice(3, message?.length - 3)
        .replaceAll("  ", "")
        .replaceAll(`'`, `"`)
    );

    if (renderNow) {
      if (parsedData.transcript) {
        const allAnswers = messagesData?.filter((msg) => msg.message?.startsWith("end::"));

        const specificAnswerThisOption = allAnswers.find((m) => m.message?.includes("end::"));

        if (specificAnswerThisOption) {
          return (
            <div style={Object.assign({}, { display: "flex", flexDirection: "row" })}>
              <LoadingIcon />
              <span>{lang("thanks_for_your_feedback")}</span>
            </div>
          );
        }

        return (
          <OptionComponent
            lang={lang}
            conversationToken={conversationToken}
            channelToken={channelToken}
            data={[{ ...parsedData, type: "end" }]}
            saveAndEmitMessage={saveAndEmitMessage}
          />
        );
      }

      const allAnswers = messagesData?.filter((msg) => msg.message?.startsWith("option::"));
      const specificAnswerThisOption = allAnswers.find((m) => m.message?.includes("option::" + parsedData.id + "-"));

      if (specificAnswerThisOption) {
        return <UserAnswered ask={parsedData.label} lang={lang} answers={JSON.parse(specificAnswerThisOption.message?.split("-")[1].split("::")[0])[0]} />;
      }

      return (
        <OptionComponent
          data={[parsedData]}
          lang={lang}
          saveAndEmitMessage={saveAndEmitMessage}
          hasChainedOptionsActive={hasChainedOptionsActive}
          conversationToken={conversationToken}
          channelToken={channelToken}
        />
      );
    }

    return true;
  }

  function generateDateInTimeZone(timezone = "Europe/Lisbon") {
    const dt = luxon.DateTime.now().setZone(timezone);
    return dt.toFormat("yyyy-MM-dd HH:mm:ss");
  }

  function formatDate(date, tzServer = "") {
    let dt;
    if (tzServer) {
      dt = luxon.DateTime.fromJSDate(date, { zone: tzServer });
    } else {
      dt = luxon.DateTime.fromJSDate(date);
    }
    return dt.toFormat("yyyy-MM-dd HH:mm:ss");
  }

  function isChatAvailable(data, currentTime, setIsUnavailableDueTime = false) {
    const weekdays = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
    const weekdayData = JSON.parse(data ?? "{}")?.weekday;

    // Get the current weekday
    const currentWeekday = weekdays[new Date(currentTime).getDay()];

    if (currentWeekday in weekdayData) {
      const currentDayData = weekdayData[currentWeekday];
      const morningStart = currentDayData?.morning_start ?? "00:00";
      const morningEnd = currentDayData?.morning_end ?? "00:00";
      const afternoonStart = currentDayData?.afternoon_start ?? "00:00";
      const afternoonEnd = currentDayData?.afternoon_end ?? "00:00";

      // console.log(
      //   "AVAILABILITY: ",
      //   "\nMORNING START: ",
      //   morningStart,
      //   "\nMORNING END: ",
      //   morningEnd,
      //   "\nAFTERNOON START: ",
      //   afternoonStart,
      //   "\nAFTERNOON END: ",
      //   afternoonEnd
      // );

      if (
        morningStart &&
        morningStart === "00:00" &&
        morningEnd &&
        morningEnd === "11:59" &&
        afternoonStart &&
        afternoonStart === "12:00" &&
        afternoonEnd &&
        afternoonEnd === "23:59"
      ) {
        return true;
      }

      if (
        morningStart &&
        morningStart !== "00:00" &&
        morningEnd &&
        morningEnd !== "00:00" &&
        afternoonStart &&
        afternoonStart !== "00:00" &&
        afternoonEnd &&
        afternoonEnd !== "00:00"
      ) {
        const [morningStartHour, morningStartMinute] = morningStart.split(":");
        const [morningEndHour, morningEndMinute] = morningEnd.split(":");
        const [afternoonStartHour, afternoonStartMinute] = afternoonStart.split(":");
        const [afternoonEndHour, afternoonEndMinute] = afternoonEnd.split(":");

        const morningStartDate = new Date(currentTime);
        morningStartDate.setHours(Number(morningStartHour), Number(morningStartMinute), 0);

        const morningEndDate = new Date(currentTime);
        morningEndDate.setHours(Number(morningEndHour), Number(morningEndMinute), 0);

        const afternoonStartDate = new Date(currentTime);
        afternoonStartDate.setHours(Number(afternoonStartHour), Number(afternoonStartMinute), 0);

        const afternoonEndDate = new Date(currentTime);
        afternoonEndDate.setHours(Number(afternoonEndHour), Number(afternoonEndMinute), 0);

        if ((currentTime >= morningStartDate && currentTime <= morningEndDate) || (currentTime >= afternoonStartDate && currentTime <= afternoonEndDate)) {
          return true;
        }
      }

      if (
        morningStart &&
        morningStart !== "00:00" &&
        morningEnd &&
        morningEnd !== "00:00" &&
        (!afternoonStart || afternoonStart === "00:00") &&
        (!afternoonEnd || afternoonEnd === "00:00")
      ) {
        const [morningStartHour, morningStartMinute] = morningStart.split(":");
        const [morningEndHour, morningEndMinute] = morningEnd.split(":");

        const morningStartDate = new Date(currentTime);
        morningStartDate.setHours(Number(morningStartHour), Number(morningStartMinute), 0);

        const morningEndDate = new Date(currentTime);
        morningEndDate.setHours(Number(morningEndHour), Number(morningEndMinute), 0);

        if (currentTime >= morningStartDate && currentTime <= morningEndDate) {
          console.log(">>>>> Available chat");
          return true;
        }
      }

      if (
        (!morningStart || morningStart === "00:00") &&
        (!morningEnd || morningEnd === "00:00") &&
        afternoonStart &&
        afternoonStart !== "00:00" &&
        afternoonEnd &&
        afternoonEnd !== "00:00"
      ) {
        const [afternoonStartHour, afternoonStartMinute] = afternoonStart.split(":");
        const [afternoonEndHour, afternoonEndMinute] = afternoonEnd.split(":");

        const afternoonStartDate = new Date(currentTime);
        afternoonStartDate.setHours(Number(afternoonStartHour), Number(afternoonStartMinute), 0);

        const afternoonEndDate = new Date(currentTime);
        afternoonEndDate.setHours(Number(afternoonEndHour), Number(afternoonEndMinute), 0);

        if (currentTime >= afternoonStartDate && currentTime <= afternoonEndDate) {
          console.log(">>>>> Available chat");
          return true;
        }
      }
    }

    if (setIsUnavailableDueTime) {
      setIsUnavailableDueTime(true);
    }
    console.log(">>>>> Not Available chat");
    return false;
  }

  class AxiosHandler {
    constructor(baseURL, headers = {}) {
      this.instance = axios.create({
        baseURL,
        headers,
      });
    }

    // Define a method for making GET requests.
    async get(url, params = {}) {
      try {
        const response = await this.instance.get(url, { params });
        return response.data;
      } catch (error) {
        throw error;
      }
    }

    // Define a method for making POST requests.
    async post(url, data = {}) {
      try {
        const response = await this.instance.post(url, data);
        return response.data;
      } catch (error) {
        throw error;
      }
    }

    // Define a method for making PUT requests.
    async put(url, data = {}) {
      try {
        const response = await this.instance.put(url, data);
        return response.data;
      } catch (error) {
        throw error;
      }
    }

    // Define a method for making DELETE requests.
    async delete(url) {
      try {
        const response = await this.instance.delete(url);
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }

  const apiWebsite = new AxiosHandler(`${domainBaseURL}/api`);
  const apiFlowiseBaseURL = "https://sellz.ai";

  function findLocalStorageValue(partialKeyName) {
    if (typeof window !== "undefined") {
      for (let i = 0; i < window.localStorage.length; i++) {
        const key = window.localStorage.key(i);
        if (key.includes(partialKeyName)) {
          return window.localStorage.getItem(key);
        }
      }
      return null; // Return null if no matching key is found
    }
    return null;
  }

  const elapsedDate = (originalDate) => {
    if (!originalDate) return "no time";
    const date1 = new Date(originalDate);
    const date2 = new Date();
    const diffTime = Math.abs(Number(date2) - Number(date1));
    const finalTime = Number((diffTime / 1000 / 60).toFixed(0));

    if (finalTime < 59) {
      return `${finalTime}m`;
    }
    if (finalTime >= 60 && finalTime <= 1440) {
      return `${Math.floor(finalTime / 60).toFixed(0)}h`;
    }
    if (finalTime > 1440) {
      return `${(finalTime / 60 / 24).toFixed(0)}d`;
    }

    return "";
  };

  const Container = ({
    children,
    isChatAvailableNow,
    chatSession,
    showListChatIcon,
    customStyle,
    startedChat,
    lang,
    channelData,
    disableAi,
    activeAi,
    endConversation,
    oldConversations,
    showOldConversations,
    toggleOldConversations,
    messagesData,
    openImageModal,
    optionsChain,
    selectedChannel,
    showFormInMessage,
  }) => {
    return (
      <div>
        {startedChat ? (
          <div style={Object.assign({}, { display: "flex", alignContent: "center", justifyContent: "space-between", alignItems: "center", padding: 12.5 })}>
            <div
              className="hover-text"
              style={Object.assign({}, { cursor: "pointer" })}
              onClick={() => {
                window.TOGGLE_MODAL["toggle_" + sufixGUID]("#chat-box-" + sufixGUID);
              }}
            >
              <OpenModalIcon />
              <span className="tooltip-text" id="tooltip-left">
                {lang("open_chat_in_modal")}
              </span>
            </div>
            {startedChat && showListChatIcon ? (
              <div className="hover-text" style={Object.assign({}, { cursor: "pointer" })} onClick={toggleOldConversations}>
                <ListChatIcon />
                <span className="tooltip-text" id="tooltip-left">
                  {lang("see_old_conversations")}
                </span>
              </div>
            ) : (
              <></>
            )}
            {false ? (
              <div className="hover-text" style={Object.assign({}, { cursor: "pointer" })} onClick={disableAi}>
                <AgentIcon />
                <span className="tooltip-text" id="tooltip-left">
                  {lang("call_an_agent")}
                </span>
              </div>
            ) : (
              <></>
            )}
            {startedChat && findLocalStorageValue("UNAUTH_CONV_TOKEN_CHANNEL_" + sufixGUID + "_" + selectedChannel) ? (
              <div className="hover-text" style={Object.assign({}, { cursor: "pointer", marginLeft: 5, marginRight: 3.5 })} onClick={endConversation}>
                <EndChatIcon />
                <span className="tooltip-text" id="tooltip-left">
                  {lang("finish_conversation")}
                </span>
              </div>
            ) : (
              <></>
            )}
            <div className="hover-text" style={Object.assign({}, { cursor: "pointer" })} onClick={openInNewTab}>
              <NewTabIcon />
              <span className="tooltip-text" id="tooltip-left">
                {lang("open_chat_new_tab")}
              </span>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="ebsss-widget-container" style={Object.assign({}, startedChat ? { paddingRight: 5, paddingLeft: 10 } : {})}>
          {showOldConversations ? (
            <div>
              <div
                style={Object.assign(
                  {},
                  {
                    paddingTop: 30,
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "space-between",
                    borderRadius: 10,
                    background: `url(${domainBaseURL + "/files/" + customStyle.header_background_image_value})`,
                    marginRight: 5,
                    backgroundSize: "cover",
                  }
                )}
              >
                <div style={Object.assign({}, { marginLeft: 15 })}>
                  <ChatElementHeader
                    title={lang("conversations_history")}
                    description={lang("your_already_finished_conversations")}
                    icon={
                      <div onClick={toggleOldConversations} style={Object.assign({}, { cursor: "pointer" })}>
                        <BackwardIcon />
                      </div>
                    }
                  />
                </div>
              </div>
              <ConversationMenu
                customStyle={customStyle}
                messagesData={messagesData}
                openImageModal={openImageModal}
                optionsChain={optionsChain}
                selectedChannel={selectedChannel}
                showFormInMessage={showFormInMessage}
                lang={lang}
                chatSession={chatSession}
              >
                {oldConversations
                  ?.sort((a, b) => parseDate(b.created_at) - parseDate(a.created_at))
                  ?.map((oldConvs, i) => {
                    return <ConversationContact lang={lang} conversation={oldConvs} key={i} />;
                  })}
              </ConversationMenu>
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    );
  };

  const ChatArea = ({ children }) => {
    return <div className="ebsss-widget-chat-area">{children}</div>;
  };

  const ChatWelcomeScreen = ({ customStyle, children, lang }) => {
    return (
      <ChatArea>
        <div
          className="ebsss-chat-initial-welcome-container"
          style={Object.assign(
            {},
            {
              backgroundImage: `url(${domainBaseURL + "/files/" + customStyle.header_background_image_value})`,
            }
          )}
        >
          <div className="ebsss-chat-initial-welcome-header">
            <ChatWelcomeElementHeader
              title={customStyle.header_title}
              description={customStyle.header_message}
              image={
                customStyle?.brand_header_image_value
                  ? domainBaseURL + "/files/" + customStyle.brand_header_image_value
                  : "https://th.bing.com/th/id/R.ec2b0f17903e99d969e7b97956be2799?rik=EWDVzSZjXFzukQ&pid=ImgRaw&r=0"
              }
            />
          </div>
        </div>
        {children}
      </ChatArea>
    );
  };

  const ConversationMenu = ({ children, customStyle, messagesData, openImageModal, optionsChain, selectedChannel, showFormInMessage, lang, chatSession }) => {
    const [showingOld, setShowingOld] = React.useState(null);

    const displayConversation = (conversationToSee = null) => {
      setShowingOld(conversationToSee);
    };

    const modifiedChildren = React.Children.map(children, (child) => {
      return React.cloneElement(child, { displayConversation });
    });

    return (
      <div className="conversation-area">
        {showingOld ? (
          <div
            style={Object.assign(
              {},
              {
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }
            )}
          >
            <div
              style={Object.assign(
                {},
                {
                  fontWeight: "400",
                  cursor: "pointer",
                  margin: "auto",
                  position: "fixed",
                  backgroundColor: "#fff",
                  width: 360,
                  zIndex: 999999999,
                  display: "flex",
                  paddingTop: 5,
                  paddingBottom: 5,
                }
              )}
            >
              <button className="btn btn-danger btn-sm m-auto" type="button" onClick={() => displayConversation()}>
                {lang("exit_history")}
              </button>
            </div>
            <div style={Object.assign({}, { width: "100%", paddingTop: 50 })}>
              {JSON.parse(showingOld?.messages_informations?.conversations_messagens ?? "[]")
                ?.filter((mes) => !mes.message?.startsWith("option::"))
                ?.filter((mes) => !mes.message?.startsWith("form::"))
                ?.filter((mes) => !mes.message?.startsWith("end::"))
                ?.filter((mes) => !mes.message?.startsWith("optionv2::"))
                ?.filter((mes) => !mes.message?.startsWith("optionv2@ai::"))
                ?.filter((mes) => !mes.message?.startsWith("speech@ai"))
                ?.filter((mes) => !mes.message?.startsWith("call@agent::"))
                ?.filter((mes) => mes.message)
                ?.map((message) =>
                  message?.is_agent === "0" && message?.is_bot === "0" ? (
                    <MessageSent
                      lang={lang}
                      customStyle={customStyle}
                      messagesData={messagesData}
                      message={message}
                      bg={customStyle?.primary_color}
                      openImageModal={openImageModal}
                      userImage={chatSession && chatSession?.profile?.avatar ? window.location.origin + "/files/" + chatSession?.profile?.avatar : null}
                    />
                  ) : (
                    <MessageReceived
                      lang={lang}
                      conversationToken={showingOld?.token}
                      channelToken={selectedChannel}
                      optionsChain={optionsChain}
                      customStyle={customStyle}
                      showFormInMessage={showFormInMessage}
                      messagesData={messagesData}
                      message={message}
                      bg={customStyle?.secondary_color}
                      openImageModal={openImageModal}
                    />
                  )
                )}
            </div>
          </div>
        ) : (
          <div>{modifiedChildren}</div>
        )}
      </div>
    );
  };

  const ConversationContact = ({ key, conversation, lang, displayConversation }) => {
    const style = {
      mainContainer: {
        backgroundColor: "#fff",
      },
      dot: {
        width: 10,
        height: 10,
        backgroundColor: "blue",
        borderRadius: 50,
        marginRight: 5,
      },
    };
    const parsedMsgsConvs = JSON.parse(conversation?.messages_informations?.conversations_messagens ?? "[]");
    const lastByAgent = parsedMsgsConvs?.filter((ms) => ms.is_agent === "1" || ms.is_bot === "1").pop();
    return (
      <div
        className="msg"
        key={key}
        onClick={() => {
          displayConversation(conversation);
        }}
        style={style.mainContainer}
      >
        {!lastByAgent?.avatar && lastByAgent?.is_bot === "1" ? (
          <div
            className="msg-profile-ia"
            style={{
              backgroundColor: "#f0ca4d",
              height: 40,
              borderRadius: 500,
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <span>{lastByAgent?.name?.split(" ")[0][0]?.toUpperCase() ?? "A"}</span>
            <span>{lastByAgent?.name?.split(" ")[1][0]?.toUpperCase() ?? "I"}</span>
          </div>
        ) : (
          <img
            className="msg-profile"
            src={
              lastByAgent?.avatar
                ? window.location.origin.concat("/files/").concat(lastByAgent.avatar)
                : "https://st4.depositphotos.com/4329009/19956/v/450/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
            }
            alt="Profile pic"
          />
        )}
        <div className="msg-detail">
          <div className="msg-username">{lastByAgent?.is_agent === "1" ? lastByAgent?.name : lastByAgent?.is_bot === "1" ? "AI" : lang("you")}</div>
          <div className="msg-content">
            <span className="msg-message">
              {lang("last_message")}:{" "}
              <span
                style={Object.assign(
                  {},
                  {
                    color: "#ccc",
                  }
                )}
              >
                {parsedMsgsConvs[parsedMsgsConvs.length - 1]?.message}
              </span>
            </span>
            <span className="msg-date">{elapsedDate(new Date(conversation.created_at))}</span>
          </div>
        </div>
      </div>
    );
  };

  const AudioPlayer = ({ audioSrc }) => {
    const [isPlaying, setIsPlaying] = React.useState(false);
    const [currentTime, setCurrentTime] = React.useState(0);
    const [duration, setDuration] = React.useState(0);
    const [audioFile, setAudioFile] = React.useState(null);

    const togglePlay = () => {
      if (isPlaying) {
        audioFile.pause();
      } else {
        audioFile.play();
      }
      setIsPlaying(!isPlaying);
    };

    const updateTime = () => {
      setCurrentTime(audioFile?.currentTime);
    };

    const updateDuration = () => {
      setDuration(audioFile?.duration);
    };

    const formatTime = (time) => {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);

      if (String(minutes) === "Infinity" || String(minutes) === "NaN" || String(seconds) === "NaN" || String(seconds) === "Infinity") {
        return "0:00";
      }

      return `${minutes}:${seconds < 10 ? 0 : ""}${seconds}`;
    };

    React.useEffect(() => {
      if (currentTime === duration) {
        setIsPlaying(false);
        updateTime();
      }
    }, [currentTime]);

    React.useEffect(() => {
      if (audioFile && !duration) {
        updateTime();
      }
    }, [audioFile]);

    return (
      <div style={Object.assign({}, { minWidth: 150 })}>
        <audio
          ref={(audioRef) => {
            if (audioRef) {
              setAudioFile(audioRef);
            }
          }}
          src={audioSrc}
          onTimeUpdate={updateTime}
          onDurationChange={updateDuration}
        />
        <div className="ebsss-chat-audio-player">
          <button type="button" onClick={togglePlay}>
            {isPlaying ? <PauseIcon /> : <PlayIcon />}
          </button>
          <progress max={duration} value={currentTime} />
        </div>
        <span>{formatTime(currentTime)}</span> /
        <span>{audioFile?.duration && audioFile?.duration !== "Infinity" && audioFile?.duration !== "NaN" ? formatTime(audioFile?.duration) : "0:00"}</span>
      </div>
    );
  };

  const MessageReceived = ({
    lang,
    customStyle,
    messagesData,
    message,
    bg,
    openImageModal,
    saveAndEmitMessage,
    optionsChain,
    conversationToken,
    channelToken,
  }) => {
    if (message?.message === "CHAT_OPTIONV2") {
      return (
        <PickAiButtons
          flow={JSON.parse(message.flow)?.chain?.flow}
          message={message}
          messagesData={messagesData}
          customStyle={customStyle}
          saveAndEmitMessage={saveAndEmitMessage}
        />
      );
    }
    return handleElementString(message?.message, lang) ? (
      <div
        className="ebsss-widget-chat-msg"
        key={message?.id}
        style={messagesData.findIndex((ms) => ms.id === message?.id) === 0 ? Object.assign({}, { marginTop: 10 }) : {}}
      >
        <div className="ebsss-widget-chat-msg-profile">
          {customStyle?.hide_agent_image && customStyle?.hide_agent_image === "on" ? (
            <></>
          ) : message?.avatar && message?.avatar?.length > 0 ? (
            <img className="ebsss-widget-chat-msg-img" src={domainBaseURL + "/files/" + message?.avatar} alt="Profile pic" />
          ) : (
            <div
              style={{
                backgroundColor: "#f0ca4d",
                width: 40,
                height: 40,
                borderRadius: 500,
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
              }}
            >
              <span>{message?.name?.split(" ")[0][0]?.toUpperCase() ?? "A"}</span>
              <span>{message?.name?.split(" ")[1][0]?.toUpperCase() ?? "I"}</span>
            </div>
          )}
          <div className="ebsss-widget-chat-msg-date">
            <span>{correctToTimeZone(message?.datetime)}</span>
          </div>
        </div>
        {handleElementString(message?.message, lang, optionsChain, messagesData, true, saveAndEmitMessage, conversationToken, channelToken)}
      </div>
    ) : (
      <div
        className="ebsss-widget-chat-msg"
        key={message?.id}
        style={messagesData.findIndex((ms) => ms.id === message?.id) === 0 ? Object.assign({}, { marginTop: 10 }) : {}}
      >
        <div className="ebsss-widget-chat-msg-profile">
          {customStyle?.hide_agent_image && customStyle?.hide_agent_image === "on" ? (
            <></>
          ) : message?.avatar ? (
            <img className="ebsss-widget-chat-msg-img" src={domainBaseURL + "/files/" + message?.avatar} alt="Profile pic" />
          ) : (
            <div
              style={{
                backgroundColor: "#f0ca4d",
                width: 40,
                height: 40,
                borderRadius: 500,
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
              }}
            >
              <span>{message?.name?.split(" ")[0][0]?.toUpperCase() ?? "A"}</span>
              <span>{message?.name?.split(" ")[1][0]?.toUpperCase() ?? "I"}</span>
            </div>
          )}
          <div className="ebsss-widget-chat-msg-date">
            <span>{correctToTimeZone(message?.datetime)}</span>
          </div>
        </div>
        <div className="ebsss-widget-chat-msg-content">
          <div
            className="ebsss-widget-chat-msg-text"
            ref={(el) => {
              if (bg) {
                if (el) {
                  el.style.backgroundColor = bg;
                }
              }
            }}
            style={Object.assign({}, { color: "#000" })}
          >
            {message?.name ? <p style={Object.assign({}, { color: "#000", fontWeight: "bold" })}>{message?.name}</p> : <></>}
            {(() => {
              if (message?.message?.includes("chat_conversations/image")) {
                if (message?.message?.includes(".pdf")) {
                  return (
                    <a href={domainBaseURL + "/files/" + message?.message} target="_blank" rel="noreferrer">
                      {lang("see_file")} [.{getFileExtension(message?.message)}]
                    </a>
                  );
                } else if (message?.message?.includes(".ogg")) {
                  return <AudioPlayer audioSrc={domainBaseURL + "/files/" + message?.message} />;
                } else {
                  return (
                    <img
                      src={domainBaseURL + "/files/" + message?.message}
                      style={Object.assign({}, { maxWidth: "75%", height: "auto" })}
                      onClick={() => openImageModal(domainBaseURL + "/files/" + message?.message)}
                    />
                  );
                }
              } else {
                return renderBreakLines(message?.message);
              }
            })()}
          </div>
        </div>
      </div>
    );
  };

  const MessageSent = ({ lang, customStyle, messagesData, message, bg, openImageModal, saveAndEmitMessage, userImage }) => {
    return handleElementString(message?.message, lang) ? (
      <div
        className="ebsss-widget-chat-msg ebsss-widget-owner"
        key={message?.id}
        style={messagesData.findIndex((ms) => ms.id === message?.id) === 0 ? Object.assign({}, { marginTop: 10 }) : {}}
      >
        <div className="ebsss-widget-chat-msg-profile">
          {!customStyle?.display_user_image ? (
            /*&& customStyle?.display_user_image === "on"*/ <img
              className="ebsss-widget-chat-msg-img"
              src={
                userImage
                  ? userImage
                  : "https://st4.depositphotos.com/4329009/19956/v/450/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
              }
              alt="Profile pic"
            />
          ) : (
            <></>
          )}
          <div className="ebsss-widget-chat-msg-date">
            <span>{correctToTimeZone(message?.datetime)}</span>
          </div>
        </div>
        {handleElementString(message?.message, lang, false, messagesData, true, saveAndEmitMessage)}
      </div>
    ) : (
      <div
        className="ebsss-widget-chat-msg ebsss-widget-owner"
        key={message?.id}
        style={messagesData.findIndex((ms) => ms.id === message?.id) === 0 ? Object.assign({}, { marginTop: 10 }) : {}}
      >
        <div className="ebsss-widget-chat-msg-profile">
          {!customStyle?.display_user_image ? (
            /*&& customStyle?.display_user_image === "on"*/ <img
              className="ebsss-widget-chat-msg-img"
              src={
                userImage
                  ? userImage
                  : "https://st4.depositphotos.com/4329009/19956/v/450/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
              }
              alt="Profile pic"
            />
          ) : (
            <></>
          )}
          <div className="ebsss-widget-chat-msg-date">
            <span>{correctToTimeZone(message?.datetime)}</span>
          </div>
        </div>
        <div className="ebsss-widget-chat-msg-content">
          <div
            className="ebsss-widget-chat-msg-text"
            ref={(el) => {
              if (bg) {
                if (el) {
                  el.style.backgroundColor = bg;
                }
              }
            }}
            style={Object.assign({}, { color: "#000" })}
          >
            {(() => {
              if (message?.message?.includes("chat_conversations/image")) {
                if (message?.message?.includes(".pdf")) {
                  return (
                    <a href={domainBaseURL + "/files/" + message?.message} target="_blank" rel="noreferrer">
                      {lang("see_file")} [.{getFileExtension(message?.message)}]
                    </a>
                  );
                } else if (message?.message?.includes(".ogg")) {
                  return <AudioPlayer audioSrc={domainBaseURL + "/files/" + message?.message} />;
                } else {
                  return (
                    <img
                      src={domainBaseURL + "/files/" + message?.message}
                      style={Object.assign({}, { maxWidth: "75%", height: "auto" })}
                      onClick={() => openImageModal(domainBaseURL + "/files/" + message?.message)}
                    />
                  );
                }
              } else {
                return renderBreakLines(message?.message);
              }
            })()}
          </div>
        </div>
      </div>
    );
  };

  const ChatAreaWrapper = ({
    children,
    lang,
    startedChat,
    activeAi,
    channelData,
    isChatAvailableNow,
    disableAi,
    backgroundImage,
    messagesData,
    typeEffect,
  }) => {
    const scrollingDivRef = React.useRef(null);

    function scrollToBottom() {
      if (scrollingDivRef.current) {
        scrollingDivRef.current.scrollTop = scrollingDivRef.current.scrollHeight;
      }
    }

    const wrapperStyles = {
      overflowY: "scroll",
      position: "relative",
    };

    const backgroundStyles = {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: "cover",
      opacity: 0.075, // Adjust the opacity as needed
      zIndex: -1,
    };

    React.useEffect(() => {
      if (messagesData.length > 0) {
        scrollToBottom();
      }
    }, [messagesData, typeEffect]);

    return (
      <>
        {startedChat && activeAi && !channelData?.only_chatbot && isChatAvailableNow ? (
          <div
            onClick={disableAi}
            className="btn btn-sm btn-outline-white shadow-sm my-2"
            style={Object.assign(
              {},
              {
                backgroundColor: "#00000000",
                borderRadius: 10,
                padding: 5,
                marginRight: 3.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "0.5px solid #2b5e1d",
                cursor: "pointer",
              }
            )}
          >
            <span style={Object.assign({}, { color: "#366ea7 !important" })}>
              <AgentIcon /> {lang("call_an_agent")}
            </span>
          </div>
        ) : (
          <></>
        )}
        <div className="ebsss-widget-chat-area-wrapper" ref={scrollingDivRef} style={wrapperStyles}>
          <div style={backgroundStyles}></div>
          <div className="ebsss-widget-chat-area-main">{children}</div>
        </div>
      </>
    );
  };

  const FileUploadComponent = ({ selectedFile, setSelectedFile, activeAi }) => {
    const fileValidator = (file) => {
      if (!file) {
        // No file selected
        return;
      }

      const allowedExtensions = ["jpg", "jpeg", "png", "gif", "pdf"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (allowedExtensions.includes(fileExtension)) {
        return true;
      } else {
        setSelectedFile(null);
        return false;
      }
    };

    const handleFileChange = (e) => {
      const file = e.target.files[0];

      if (!fileValidator(file)) {
        alert("Only jpg, jpeg, png, gif and .pdf.");
        return;
      }

      setSelectedFile(file);
    };

    return !activeAi ? (
      <div
        className="ebsss-widget-file-upload"
        style={Object.assign(
          {},
          {
            marginRight: 5,
            marginLeft: 5,
            marginTop: 8,
          }
        )}
      >
        <label htmlFor="file-input">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 26 26"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-paperclip"
          >
            <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"></path>
          </svg>
        </label>
        <input
          style={Object.assign(
            {},
            {
              display: "none",
            }
          )}
          type="file"
          id="file-input"
          accept=".jpg, .jpeg, .png, .pdf" // Specify the allowed file types
          onChange={handleFileChange}
        />
      </div>
    ) : (
      <></>
    );
  };

  function NoAgentIcon() {
    return (
      <svg fill="#000000" width="18px" height="18px" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
        <path d="M22,37a17.19,17.19,0,0,1,2.3-8.2c1.7-3,3.6-4.2,5.1-6.4a14.64,14.64,0,0,0,1.4-13A10,10,0,0,0,21,3a10,10,0,0,0-9.4,6.9c-1.6,4.5-.9,9.9,2.7,13.3,1.5,1.4,2.9,3.6,2.1,5.7s-3.1,2.9-4.8,3.7C7.7,34.3,3,36.7,2.2,41.3A6.22,6.22,0,0,0,8.1,49h17a1,1,0,0,0,.8-1.6A16,16,0,0,1,22,37Z" />
        <path d="M46.5,28.5a12,12,0,1,0,0,17A12,12,0,0,0,46.5,28.5ZM32.3,31.3a7.91,7.91,0,0,1,9.8-1.2l-11,11A7.91,7.91,0,0,1,32.3,31.3ZM43.7,42.7A8.36,8.36,0,0,1,33.9,44l11-11A8.05,8.05,0,0,1,43.7,42.7Z" />
      </svg>
    );
  }

  function RobotIcon() {
    return (
      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 11C6.94772 11 6.5 11.4477 6.5 12C6.5 12.5523 6.94772 13 7.5 13C8.05228 13 8.5 12.5523 8.5 12C8.5 11.4477 8.05228 11 7.5 11ZM5.5 12C5.5 10.8954 6.39543 10 7.5 10C8.60457 10 9.5 10.8954 9.5 12C9.5 13.1046 8.60457 14 7.5 14C6.39543 14 5.5 13.1046 5.5 12Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 11C15.9477 11 15.5 11.4477 15.5 12C15.5 12.5523 15.9477 13 16.5 13C17.0523 13 17.5 12.5523 17.5 12C17.5 11.4477 17.0523 11 16.5 11ZM14.5 12C14.5 10.8954 15.3954 10 16.5 10C17.6046 10 18.5 10.8954 18.5 12C18.5 13.1046 17.6046 14 16.5 14C15.3954 14 14.5 13.1046 14.5 12Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 15.5C10.2761 15.5 10.5 15.7239 10.5 16L10.5003 16.0027C10.5003 16.0027 10.5014 16.0073 10.5034 16.0122C10.5074 16.022 10.5171 16.0405 10.5389 16.0663C10.5845 16.1202 10.6701 16.1902 10.8094 16.2599C11.0883 16.3993 11.5085 16.5 12 16.5C12.4915 16.5 12.9117 16.3993 13.1906 16.2599C13.3299 16.1902 13.4155 16.1202 13.4611 16.0663C13.4829 16.0405 13.4926 16.022 13.4966 16.0122C13.4986 16.0073 13.4997 16.0027 13.4997 16.0027L13.5 16C13.5 15.7239 13.7239 15.5 14 15.5C14.2761 15.5 14.5 15.7239 14.5 16C14.5 16.5676 14.0529 16.9468 13.6378 17.1543C13.1928 17.3768 12.6131 17.5 12 17.5C11.3869 17.5 10.8072 17.3768 10.3622 17.1543C9.9471 16.9468 9.5 16.5676 9.5 16C9.5 15.7239 9.72386 15.5 10 15.5Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 5.5V7.5H8V5.5C8 5.22386 7.77614 5 7.5 5C7.22386 5 7 5.22386 7 5.5V7.5H6C4.61929 7.5 3.5 8.61929 3.5 10V17C3.5 18.3807 4.61929 19.5 6 19.5H18C19.3807 19.5 20.5 18.3807 20.5 17V10C20.5 8.61929 19.3807 7.5 18 7.5H17V5.5C17 5.22386 16.7761 5 16.5 5C16.2239 5 16 5.22386 16 5.5ZM6 8.5C5.17157 8.5 4.5 9.17157 4.5 10V17C4.5 17.8284 5.17157 18.5 6 18.5H18C18.8284 18.5 19.5 17.8284 19.5 17V10C19.5 9.17157 18.8284 8.5 18 8.5H6Z"
          fill="#fff"
        />
      </svg>
    );
  }

  function PauseIcon() {
    return (
      <svg width="18px" height="18px" viewBox="-1 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>multimedia / 11 - multimedia, pause icon</title>
        <g id="Free-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <g transform="translate(-896.000000, -378.000000)" id="Group" stroke="#EFEFEF" strokeWidth="2">
            <g transform="translate(893.000000, 376.000000)" id="Shape">
              <path d="M5.77777778,21 C4.79593822,21 4,20.0050772 4,18.7777778 L4,5.22222222 C4,3.99492278 4.79593822,3 5.77777778,3 L8.22222222,3 C9.20406178,3 10,3.99492278 10,5.22222222 L10,18.7777778 C10,20.0050772 9.20406178,21 8.22222222,21 L5.77777778,21 Z"></path>
              <path d="M14,5.22222222 C14,3.99492278 14.7959382,3 15.7777778,3 L18.2222222,3 C19.2040618,3 20,3.99492278 20,5.22222222 L20,18.7777778 C20,20.0050772 19.2040618,21 18.2222222,21 L15.7777778,21 C14.7959382,21 14,20.0050772 14,18.7777778 L14,5.22222222 Z"></path>
            </g>
          </g>
        </g>
      </svg>
    );
  }

  function PlayIcon() {
    return (
      <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>multimedia / 9 - multimedia, play icon</title>
        <g id="Free-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <g transform="translate(-749.000000, -379.000000)" id="Group" stroke="#EFEFEF" strokeWidth="2">
            <g transform="translate(745.000000, 376.000000)" id="Shape">
              <path d="M5,4.67805648 C5,4.56284567 5.03231968,4.44953549 5.09390785,4.34882312 C5.29405709,4.02152811 5.74836552,3.90360587 6.10863414,4.08543644 L20.6160344,11.4074417 C20.7378493,11.4689227 20.8382812,11.5601626 20.9059562,11.6708284 C21.1061054,11.9981234 20.976303,12.4108512 20.6160344,12.5926818 L6.10863414,19.9146871 C5.99777542,19.9706384 5.87304972,20 5.7462319,20 C5.3340994,20 5,19.6964791 5,19.322067 L5,4.67805648 Z"></path>
            </g>
          </g>
        </g>
      </svg>
    );
  }

  function AnimatedCircles() {
    React.useEffect(() => {
      const circles = document.querySelectorAll("#circle-typing");

      circles.forEach((circle, index) => {
        const delay = -0.3125 * index;
        const duration = 1000;

        circle.animate([{ r: "0" }, { r: "0" }, { r: "10" }, { r: "20" }, { r: "10" }], {
          delay,
          duration,
          iterations: Infinity,
          easing: "cubic-bezier(0, 0.5, 0.5, 1)",
        });

        circle.animate([{ cx: "16" }, { cx: "16" }, { cx: "16" }, { cx: "50" }, { cx: "84" }], {
          delay,
          duration,
          iterations: Infinity,
          easing: "cubic-bezier(0, 0.5, 0.5, 1)",
        });
      });
    }, []);

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        width="20"
        height="20"
        style={{ shapeRendering: "auto", display: "block", background: "rgb(255, 255, 255)", marginLeft: 5 }}
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g>
          <circle id="circle-typing" fill="#1c79c0" r="10" cy="50" cx="84" />
          <circle id="circle-typing" fill="#1c79c0" r="10" cy="50" cx="16" />
          <circle id="circle-typing" fill="#0dd3ff" r="10" cy="50" cx="50" />
          <circle id="circle-typing" fill="#0389ff" r="10" cy="50" cx="84" />
          <circle id="circle-typing" fill="#1c79c0" r="10" cy="50" cx="16" />
        </g>
      </svg>
    );
  }

  function TypingAnimationIcon() {
    return (
      <div style={Object.assign({}, { marginTop: 10 })}>
        <AnimatedCircles />
      </div>
    );
  }

  function CheckIcon() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" style={Object.assign({}, { marginRight: 5 })}>
        <circle opacity="0.5" cx="12" cy="12" r="10" stroke="#274f17" strokeWidth="1.5" />
        <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke="#143008" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  function SmileIcon({ onClick }) {
    return (
      <div
        onClick={onClick}
        style={Object.assign(
          {},
          {
            marginRight: 5,
            marginLeft: 5,
            marginTop: 5,
          }
        )}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-smile"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01" />
        </svg>
      </div>
    );
  }

  function MicIcon({ color }) {
    return (
      <svg
        width="22px"
        height="22px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={Object.assign(
          {},
          {
            marginTop: 7,
            marginLeft: 4,
          }
        )}
      >
        <path
          d="M8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V5Z"
          fill={color ?? "#C1C7CD"}
        />
        <path
          d="M6.25 11.8438V12C6.25 13.525 6.8558 14.9875 7.93414 16.0659C9.01247 17.1442 10.475 17.75 12 17.75C13.525 17.75 14.9875 17.1442 16.0659 16.0659C17.1442 14.9875 17.75 13.525 17.75 12V11.8438C17.75 11.2915 18.1977 10.8438 18.75 10.8438H19.25C19.8023 10.8438 20.25 11.2915 20.25 11.8437V12C20.25 14.188 19.3808 16.2865 17.8336 17.8336C16.5842 19.0831 14.9753 19.8903 13.25 20.1548V22C13.25 22.5523 12.8023 23 12.25 23H11.75C11.1977 23 10.75 22.5523 10.75 22V20.1548C9.02471 19.8903 7.41579 19.0831 6.16637 17.8336C4.61919 16.2865 3.75 14.188 3.75 12V11.8438C3.75 11.2915 4.19772 10.8438 4.75 10.8438H5.25C5.80228 10.8438 6.25 11.2915 6.25 11.8438Z"
          fill={color ?? "#C1C7CD"}
        />
      </svg>
    );
  }

  const AudioCapture = ({ handleDeleteRecording, handleStartRecording, handleStopRecording, handlePlayRecording, audioChunks, recording }) => {
    return (
      <div className="d-flex">
        {!recording ? (
          <div style={Object.assign({}, { width: 33 })} onClick={handleStartRecording}>
            <MicIcon />
          </div>
        ) : (
          <div style={Object.assign({}, { width: 33 })} onClick={handleStopRecording}>
            <MicIcon color="red" />
          </div>
        )}

        {audioChunks.length !== 0 ? (
          <div className="d-none">
            <div style={Object.assign({}, { width: 22.5, color: "green", marginTop: 5, cursor: "pointer" })} onClick={handlePlayRecording}>
              ►
            </div>
            <div style={Object.assign({}, { width: 22.5, color: "red", marginTop: 5, fontSize: 20, cursor: "pointer" })} onClick={handleDeleteRecording}>
              ×
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  };

  const ChatAreaFooter = ({
    lang,
    pressEnter,
    onSubmit,
    onChange,
    selectedFile,
    setSelectedFile,
    valuetextMsg,
    canUploadFiles,
    openEmojis,
    handleDeleteRecording,
    handleStartRecording,
    handleStopRecording,
    handlePlayRecording,
    audioChunks,
    recording,
    pshr,
    hideAudioCapture,
    activeAi,
    channelData,
  }) => {
    return (
      <div className="ebsss-widget-chat-area-footer">
        <svg
          style={Object.assign({}, { display: "none", marginTop: -2.25 })}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-paperclip"
        >
          <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" />
        </svg>
        <svg
          style={Object.assign({}, { display: "none" })}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-smile"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01" />
        </svg>
        <input
          type="text"
          id="main-message-writer"
          onKeyDown={pressEnter}
          placeholder={lang("type_a_message")}
          onChange={onChange}
          value={valuetextMsg}
          autoComplete="off"
        />
        <SmileIcon onClick={openEmojis} />
        {canUploadFiles ? <FileUploadComponent activeAi={activeAi} selectedFile={selectedFile} setSelectedFile={setSelectedFile} /> : <></>}

        {channelData?.enable_user_speech && Number(channelData?.enable_user_speech) ? (
          activeAi ? (
            !hideAudioCapture ? (
              <AudioCapture
                handleDeleteRecording={handleDeleteRecording}
                handleStartRecording={handleStartRecording}
                handleStopRecording={handleStopRecording}
                handlePlayRecording={handlePlayRecording}
                audioChunks={audioChunks}
                recording={recording}
              />
            ) : (
              <></>
            )
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-thumbs-up"
          onClick={onSubmit}
          style={Object.assign({}, { marginTop: 6 })}
        >
          <path d="M10.3009 13.6949L20.102 3.89742M10.5795 14.1355L12.8019 18.5804C13.339 19.6545 13.6075 20.1916 13.9458 20.3356C14.2394 20.4606 14.575 20.4379 14.8492 20.2747C15.1651 20.0866 15.3591 19.5183 15.7472 18.3818L19.9463 6.08434C20.2845 5.09409 20.4535 4.59896 20.3378 4.27142C20.2371 3.98648 20.013 3.76234 19.7281 3.66167C19.4005 3.54595 18.9054 3.71502 17.9151 4.05315L5.61763 8.2523C4.48114 8.64037 3.91289 8.83441 3.72478 9.15032C3.56153 9.42447 3.53891 9.76007 3.66389 10.0536C3.80791 10.3919 4.34498 10.6605 5.41912 11.1975L9.86397 13.42C10.041 13.5085 10.1295 13.5527 10.2061 13.6118C10.2742 13.6643 10.3352 13.7253 10.3876 13.7933C10.4468 13.87 10.491 13.9585 10.5795 14.1355Z" />
        </svg>
      </div>
    );
  };

  const ChatElementHeader = ({ title, description, image, icon }) => {
    const headerStyles = {
      container: {
        textAlign: "left",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginTop: -15,
        marginBottom: 15,
      },
      profileImage: {
        borderRadius: "50%",
        width: "50px",
        height: "50px",
      },
      name: {
        fontSize: "16px",
      },
      description: {
        fontSize: "12px",
        color: "#666",
        marginTop: -12.5,
        maxHeight: "40px",
        minHeight: "40px",
        overflowY: "auto",
        wordBreak: "break-word",
        lineHeight: 1.33,
      },
      textSpace: {
        marginLeft: 15,
        overflowY: "auto",
      },
    };

    return (
      <div style={headerStyles.container}>
        {image ? <img style={headerStyles.profileImage} src={image} alt="Chat Picture" /> : <></>}
        {icon ? icon : <></>}
        <div style={headerStyles.textSpace}>
          <p style={headerStyles.name}>{title}</p>
          <p style={headerStyles.description}>{description}</p>
        </div>
      </div>
    );
  };

  const ChatWelcomeElementHeader = ({ title, description, image }) => {
    return (
      <div className="ebsss-chat-initial-header-flex">
        <p className="ebsss-chat-initial-header-name">{title}</p>
        <p className="ebsss-chat-initial-header-description">{description}</p>
      </div>
    );
  };

  const IdentifyUser = ({ formData, setFormData, setStartedChat, saveAndEmitMessage, lang }) => {
    const [fail, setFail] = React.useState(false);
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    };

    const handleSubmit = (e) => {
      e.preventDefault();
    };

    const formStyles = Object.assign(
      {},
      {
        maxWidth: "300px",
        margin: "0 auto",
        padding: "20px",
        borderRadius: "5px",
        textAlign: "center",
      }
    );

    const inputStyles = Object.assign(
      {},
      {
        width: "100%",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "5px",
      }
    );

    const labelStyles = Object.assign(
      {},
      {
        display: "block",
        fontWeight: "bold",
      }
    );

    const buttonStyles = Object.assign(
      {},
      {
        backgroundColor: "#007bff",
        color: "#fff",
        padding: "10px 20px",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
      }
    );

    const formatFormDataForDisplay = () => {
      return Object.entries(formData)
        .map(([key, value]) => `${lang(key)}: ${value}`)
        .join("\n");
    };

    return (
      <div>
        <h4 style={Object.assign({}, { textAlign: "center", marginTop: 25 })}>{lang("fill_your_data")}</h4>
        <form style={formStyles} onSubmit={handleSubmit}>
          <div style={Object.assign({}, labelStyles, { marginBottom: "10px" })}>
            <label htmlFor="name">{lang("name")}:</label>
            <input type="text" id="name" name="name" style={inputStyles} value={formData.name} onChange={handleChange} />
          </div>
          <div style={Object.assign({}, labelStyles, { marginBottom: "10px" })}>
            <label htmlFor="phoneNumber">{lang("phoneNumber")}:</label>
            <input type="text" id="phoneNumber" name="phoneNumber" style={inputStyles} value={formData.phoneNumber} onChange={handleChange} />
          </div>
          <div style={Object.assign({}, labelStyles, { marginBottom: "10px" })}>
            <label htmlFor="email">{lang("email")}:</label>
            <input type="email" id="email" name="email" style={inputStyles} value={formData.email} onChange={handleChange} />
          </div>
          <p className="mb-3 mt-3">{lang("identify_user_message")}</p>
          {fail ? <p className="text-danger">{lang("fill_data_correctly")}</p> : <></>}
          <button
            type="button"
            onClick={() => {
              if (Object.values(formData).some((val) => val.length < 3)) {
                setFail(true);
                return;
              }
              const formattedData = formatFormDataForDisplay();
              saveAndEmitMessage(false, formattedData);
              setStartedChat(true);
            }}
            style={buttonStyles}
          >
            {lang("send")}
          </button>
        </form>
      </div>
    );
  };

  function BackwardIcon() {
    return (
      <svg
        height="50px"
        width="50px"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <path style={Object.assign({}, { fill: "#A7C7FC" })} d="M256,0v512c141.158,0,256-114.842,256-256S397.158,0,256,0z" />
        <path style={Object.assign({}, { fill: "#C4D9FD" })} d="M0,256c0,141.158,114.842,256,256,256V0C114.842,0,0,114.842,0,256z" />
        <path
          style={Object.assign({}, { fill: "#5286FA" })}
          d="M319.001,115.423c-9.087-9.087-23.824-9.089-32.912,0L161.967,239.548c-4.364,4.364-6.817,10.283-6.817,16.457c0,6.173,2.451,12.092,6.817,16.457L286.089,396.58c4.544,4.541,10.501,6.814,16.457,6.814s11.913-2.273,16.455-6.817c9.089-9.089,9.089-23.824,0-32.914L211.337,256.002l107.664-107.669C328.091,139.247,328.091,124.511,319.001,115.423z"
        />
      </svg>
    );
  }

  function EndChatIcon() {
    return (
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24">
        <defs>
          <style>{`.cls-2{fill:none;stroke:#8f0000ab;stroke-miterlimit:10;stroke-width:1.91px;}`}</style>
        </defs>
        <polyline className="cls-2" points="12.08 9.99 9.3 7.21 12.08 4.42" />
        <path
          className="cls-2"
          d="M1.5,5.3v9.54a3.82,3.82,0,0,0,3.82,3.82H7.23v2.86L13,18.66h5.73a3.82,3.82,0,0,0,3.82-3.82V5.3a3.82,3.82,0,0,0-3.82-3.82H5.32A3.82,3.82,0,0,0,1.5,5.3Z"
        />
        <path className="cls-2" d="M9.14,7.2H12A3.82,3.82,0,1,1,8.18,11" />
      </svg>
    );
  }

  function AgentIcon(props) {
    return (
      <svg width="28px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <defs>
          <style>{`.cls-1{fill:none;stroke:#366ea7;stroke-miterlimit:10;stroke-width:1.91px;}`}</style>
        </defs>
        <rect className="cls-1" x="6.27" y="5.32" width="11.45" height="15.27" rx="5.73" />
        <path className="cls-1" d="M17.73,9.14h1.91A2.86,2.86,0,0,1,22.5,12v1.91a2.86,2.86,0,0,1-2.86,2.86H17.73a0,0,0,0,1,0,0V9.14A0,0,0,0,1,17.73,9.14Z" />
        <path
          className="cls-1"
          d="M1.5,9.14H3.41A2.86,2.86,0,0,1,6.27,12v1.91a2.86,2.86,0,0,1-2.86,2.86H1.5a0,0,0,0,1,0,0V9.14A0,0,0,0,1,1.5,9.14Z"
          transform="translate(7.77 25.91) rotate(180)"
        />
        <path className="cls-1" d="M4.36,9.14h0A7.64,7.64,0,0,1,12,1.5h0a7.64,7.64,0,0,1,7.64,7.64h0" />
        <path className="cls-1" d="M19.64,16.77v1a4.78,4.78,0,0,1-4.78,4.77" />
      </svg>
    );
  }

  const ListChatIcon = () => {
    return (
      <svg width="22px" height="22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Edit / List_Checklist">
          <path
            id="Vector"
            d="M11 17H20M8 15L5.5 18L4 17M11 12H20M8 10L5.5 13L4 12M11 7H20M8 5L5.5 8L4 7"
            stroke="#000000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    );
  };

  const OpenModalIcon = () => {
    return (
      <svg viewBox="10.9924 10.0053 478 478" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient
            gradientUnits="userSpaceOnUse"
            cx="16"
            cy="16"
            r="16"
            id="gradient-2"
            gradientTransform="matrix(0.956, 0, 0, 0.956, -12.835534, -8.36902)"
          >
            <stop offset="0" style={Object.assign({}, { stopColor: "#000" })} />
            <stop offset="1" style={Object.assign({}, { stopColor: "#000" })} />
          </radialGradient>
          <radialGradient
            gradientUnits="userSpaceOnUse"
            cx="13.5"
            cy="18.5"
            r="13.5"
            id="gradient-3"
            gradientTransform="matrix(0.956, 0, 0, 0.956, -12.835534, -8.36902)"
          >
            <stop offset="0" style={Object.assign({}, { stopColor: "#000" })} />
            <stop offset="1" style={Object.assign({}, { stopColor: "#000" })} />
          </radialGradient>
        </defs>
        <g transform="matrix(15.625, 0, 0, 15.625, 211.55487060546875, 140.75531005859378)">
          <path
            fill="#000"
            d="M 17.756 20.79 L 17.756 -6.934 C 17.756 -7.725 17.113 -8.368 16.322 -8.368 L -11.402 -8.368 C -12.193 -8.368 -12.836 -7.725 -12.836 -6.934 L -12.836 1.67 C -12.836 1.934 -12.622 2.148 -12.358 2.148 C -12.094 2.148 -11.88 1.934 -11.88 1.67 L -11.88 -6.934 C -11.88 -7.198 -11.665 -7.412 -11.402 -7.412 L 16.322 -7.412 C 16.585 -7.412 16.8 -7.198 16.8 -6.934 L 16.8 20.79 C 16.8 21.054 16.585 21.268 16.322 21.268 L 7.718 21.268 C 7.454 21.268 7.24 21.482 7.24 21.746 C 7.24 22.01 7.454 22.224 7.718 22.224 L 16.322 22.224 C 17.113 22.224 17.756 21.581 17.756 20.79 Z"
            style={{ stroke: "url(#gradient-2)" }}
          />
          <path
            fill="#000"
            d="M -11.402 4.06 C -12.193 4.06 -12.836 4.703 -12.836 5.494 L -12.836 20.79 C -12.836 21.581 -12.193 22.224 -11.402 22.224 L 3.894 22.224 C 4.685 22.224 5.328 21.581 5.328 20.79 L 5.328 4.736 L 12.02 -1.956 L 12.02 4.538 C 12.02 4.802 12.234 5.016 12.498 5.016 C 12.762 5.016 12.976 4.802 12.976 4.538 L 12.976 -3.11 C 12.976 -3.374 12.762 -3.588 12.498 -3.588 L 4.85 -3.588 C 4.586 -3.588 4.372 -3.374 4.372 -3.11 C 4.372 -2.846 4.586 -2.632 4.85 -2.632 L 11.343 -2.632 L 4.651 4.06 L -11.402 4.06 Z M 4.372 20.79 C 4.372 21.054 4.157 21.268 3.894 21.268 L -11.402 21.268 C -11.665 21.268 -11.88 21.054 -11.88 20.79 L -11.88 5.494 C -11.88 5.23 -11.665 5.016 -11.402 5.016 L 4.372 5.016 L 4.372 20.79 Z"
            style={{ stroke: "url(#gradient-3)" }}
          />
        </g>
      </svg>
    );
  };

  const NewTabIcon = () => {
    return (
      <svg style={Object.assign({}, { cursor: "pointer" })} width="26px" height="26px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 12V6C5 5.44772 5.44772 5 6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H12M8.11111 12H12M12 12V15.8889M12 12L5 19"
          stroke="#292929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  const Chat = ({
    lang,
    activeAi,
    setActiveAi,
    flowAi,
    flowiseChat,
    office,
    formsData,
    customs,
    started,
    showFormInMessage,
    setInvokedForm,
    setIsUnavailableDueTime,
    isUnavailableDueTime,
    autoMessageData,
    channelData,
    reloadChatConversation,
    chatSession,
    chatOldConversations,
    employeesNow,
  }) => {
    const [selectedChannel, setSCHA] = React.useState(chatChannelId);
    const [conversationData, setCD] = React.useState({});
    const [messagesData, setMD] = React.useState([]);
    const [pusherInstance, setPI] = React.useState(null);
    const [pusherPrivate, setPusherPrivate] = React.useState(null);
    const [startedChat, setStartedChat] = React.useState(false);
    const [textMsg, setTextMsg] = React.useState("");
    const [notificationSound, setNotificationSound] = React.useState(
      new Audio("https://cdn.pixabay.com/download/audio/2021/08/09/audio_9f35254621.mp3?filename=notification-sound-7062.mp3")
    );
    const [customStyle, setCustomStyle] = React.useState(customs);
    const [officeHours, setOfficeHours] = React.useState(office);
    const [autoMessaging, setAutoMessaging] = React.useState(autoMessageData);
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [selectEmojis, setSelectEmojis] = React.useState(false);
    const [optionsChain, setOptionsChain] = React.useState(null);
    const [typeEffect, setTE] = React.useState(false);
    const [audioStream, setAudioStream] = React.useState(null);
    const [recording, setRecording] = React.useState(false);
    const [audioChunks, setAudioChunks] = React.useState([]);
    const [hideAudioCapture, setHideAudioCapture] = React.useState(false);
    const [mockSentMessage, setMockSentMessage] = React.useState("");
    const [showOldConversations, setShowOldConversations] = React.useState(false);
    const [optionsChainAnswer, setOptionsChainAnswer] = React.useState({
      id: 0,
      answer: null,
    });
    const [formData, setFormData] = React.useState({
      name: "",
      phoneNumber: "",
      email: "",
    });

    React.useEffect(() => {
      if (audioStream && recording) {
        const mediaRecorder = new MediaRecorder(audioStream);

        mediaRecorder.ondataavailable = (e) => {
          setAudioChunks([...audioChunks, e.data]);
        };
        mediaRecorder.start();

        return () => {
          mediaRecorder.stop();
        };
      }
    }, [audioStream, recording, audioChunks]);

    const handleDeleteRecording = () => {
      setAudioChunks([]);
    };

    const handleStartRecording = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        setAudioStream(stream);
        setRecording(true);
      } catch (error) {
        console.error("Error accessing microphone:", error);
      }
    };

    const handleStopRecording = () => {
      setRecording(false);
      audioStream.getTracks().forEach((track) => {
        track.stop();
      });
      //sendRecordingToServer()
    };

    const handlePlayRecording = () => {
      const audioBlob = new Blob([audioChunks.pop()], { type: "audio/wav" });
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);
      audio.play();
    };

    const sendRecordingToServer = async () => {
      try {
        const audioBlob = new Blob([audioChunks.pop()], { type: "audio/wav" });
        await saveAndEmitMessage(true, "speech@ai", true, false, null, audioBlob);
      } catch (error) {
        console.error("Error uploading audio:", error);
      }
    };

    React.useEffect(() => {
      if (audioChunks.length && !recording) {
        sendRecordingToServer();
      }
    }, [audioChunks]);

    React.useEffect(() => {
      if (started) {
        setStartedChat(started);
      }
    }, [started]);

    const onChange = (e) => {
      setTextMsg(e.target.value);
    };

    const onSubmit = async (e) => {
      e.preventDefault();
      if (!textMsg?.length) {
        return;
      }

      setTextMsg("");
      await saveAndEmitMessage(true, textMsg);
    };

    const openImageModal = (url) => {
      window.parent.postMessage("SHOW_IMAGE_MODAL_" + sufixGUID + "#" + url, "*");
    };

    const pusherInit = () => {
      let pusher = new Pusher(pusherClient, {
        cluster: pusherCluster,
        useTLS: true,
      });

      setPI(pusher);
    };

    const pusherAuth = () => {
      function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
          (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
        );
      }

      const channel_name = "presence-channel-" + tenantId;
      const authEndpoint = `${window.location.origin}/api/chat/pusher/auth?uuid=${tenantId}`.replace("https://", "https://gestor.");

      let url = new URL(window.location);
      let nome = url.searchParams.get("nome") || "Usuário Anônimo";

      const presence_pusher_key = localStorage.getItem("presence_pusher_key") || false;

      if (!presence_pusher_key) {
        localStorage.setItem("presence_pusher_key", uuidv4());
      }

      let authOptions = {
        params: {
          id: localStorage.getItem("presence_pusher_key") || uuidv4(),
          nome: nome,
        },
      };

      let pusher = new Pusher(pusherClient, {
        cluster: pusherCluster,
        forceTLS: true,
        authEndpoint: authEndpoint,
        auth: authOptions,
      });

      let channel = pusher.subscribe(channel_name);
      let onlines = [];

      channel.bind("pusher:subscription_succeeded", function () {
        channel.members.each(function (member) {
          onlines.push({ id: member.id, nome: member.info.nome });
        });
        let arr = onlines.filter((este, i) => onlines.indexOf(este) === i);
        onlines = arr;
      });

      channel.bind("pusher:member_added", (member) => {
        onlines.push({ id: member.id, nome: member.info.nome });
        let arr = onlines.filter((este, i) => onlines.indexOf(este) === i);
        onlines = arr;
      });

      channel.bind("pusher:member_removed", (member) => {
        let index = onlines.findIndex((user) => user.id == member.id);
        if (index != -1) {
          onlines.splice(index, 1);
        }
      });
    };

    const saveInLocalHistory = (conversationToSave) => {
      const keyHistoryName = "HISTORY_CHAT_CONVERSATION_" + sufixGUID + "_" + selectedChannel;
      if (typeof window !== "undefined") {
        let actualLocalHistory = window.localStorage.getItem(keyHistoryName);
        if (!actualLocalHistory) {
          window.localStorage.setItem(keyHistoryName, JSON.stringify([conversationToSave]));
          return;
        }
        actualLocalHistory = window.localStorage.getItem(keyHistoryName);
        actualLocalHistory = JSON.parse(actualLocalHistory);
        let indexToRefresh = actualLocalHistory.findIndex((c) => c.token === conversationToSave.token);
        if (indexToRefresh !== -1) {
          actualLocalHistory[indexToRefresh] = conversationToSave;
        } else {
          actualLocalHistory.push(conversationToSave);
        }
        window.localStorage.setItem(keyHistoryName, JSON.stringify(actualLocalHistory));
      }
    };

    const saveAndEmitMessage = async (person, messageText, fromTexting = true, fromAi = false, convsTkn = "") => {
      if (!messageText) {
        return;
      }

      let msgCallAgent;
      let isAiActive = !!activeAi;

      if (messageText.startsWith("call@agent::")) {
        setActiveAi(null);
        isAiActive = false;
        msgCallAgent = JSON.parse(messageText.split("::")[1])[0];
      }

      if (messageText.startsWith("optionv2@ai::")) {
        setTE(true);
      }

      if (fromTexting) {
        if (optionsChain) {
          setOptionsChain(null);
        }

        if (window.localStorage.getItem("CHAINING_PHASE_" + sufixGUID)) {
          window.localStorage.removeItem("CHAINING_PHASE_" + sufixGUID);
        }
      }

      let data = {
        bot: fromAi ? "1" : "0",
        message: messageText,
        channel: selectedChannel,
        channel_name: channelData?.name,
        conversation_token: conversationData?.token ?? "",
        from: window.location.href,
        ai_active: isAiActive ? "1" : "0",
        user_id: fromAi ? null : chatSession?.id ?? null,
      };

      if (chatSession && person) {
        data.name = chatSession?.profile?.first_name ?? lang("guest") + " " + chatSession?.profile?.last_name ?? conversationData?.id;
      }

      if (convsTkn) {
        data.conversation_token = convsTkn;
      }

      let fileForm;

      if (selectedFile !== null) {
        let dataKeys = Object.keys(data);
        fileForm = new FormData();
        fileForm.append("file", selectedFile);
        Object.values(data).map((d, i) => {
          fileForm.append(dataKeys[i], d);
        });
      }

      if (!selectedFile && !data.message?.includes("::") && !fromAi) {
        setMockSentMessage(data.message);
      }

      await apiWebsite.post(`/chat/save_message`, selectedFile !== null ? fileForm : data).then(async (res) => {
        setCD(res.conversation);
        setMockSentMessage("");
        if (!chatSession?.id) {
          saveInLocalHistory(res.conversation);
        }
        let newMsg = JSON.parse(res.conversation?.messages_informations?.conversations_messagens ?? "[]")?.pop();
        if (messageText.startsWith("call@agent::")) {
          newMsg.message = msgCallAgent;
          newMsg.is_agent = "1";
          setMD((s) => [...s, newMsg]);
          return;
        }
        if (selectedFile) {
          setSelectedFile(null);
          return;
        }
        setMD((s) => [...s, newMsg]);
        if (isAiActive) {
          setTE(true);
        }

        if (
          (!fromAi && activeAi && messageText.startsWith("optionv2@ai::")) ||
          (!fromAi &&
            activeAi &&
            !messageText.startsWith("optionv2::") &&
            !messageText.startsWith("option::") &&
            !messageText.startsWith("form::") &&
            !messageText.startsWith("end::"))
        ) {
          const fromAiAnswer = await activeAi.process(textMsg);
          await saveAndEmitMessage(false, fromAiAnswer.answer, true, true, res.conversation.token);
        }
        setTE(false);
      });
    };

    React.useEffect(() => {
      if (optionsChain) {
        const chaining = JSON.parse(optionsChain?.chain);
        const delayChain = optionsChain?.delay;
        let chainSize = Object.values(chaining)?.length;
        let actualPhase = Number(window.localStorage.getItem("CHAINING_PHASE_" + sufixGUID));

        if (!actualPhase) {
          actualPhase = 1;
          window.localStorage.setItem("CHAINING_PHASE_" + sufixGUID, String(actualPhase));
        }

        if (actualPhase === 1) {
          delayedCallback(
            () =>
              setMD((s) => [
                ...s,
                {
                  id: 0,
                  message: chaining[actualPhase][0].rich_message,
                  user_id: null,
                  is_agent: "1",
                  is_bot: "0",
                  is_auto: "1",
                  ai_active: activeAi ? "1" : "0",
                  datetime: generateDateInTimeZone(),
                  order: 0,
                  weekday_int: "1",
                },
              ]),
            delayChain
          );
        } else {
          let phaseToGo = chaining[actualPhase]?.find((phGo) => phGo.answered_choice == optionsChainAnswer.answer && phGo.answered_id == optionsChainAnswer.id);

          if (!phaseToGo) {
            window.localStorage.removeItem("CHAINING_PHASE_" + sufixGUID);
            if (optionsChain) {
              setOptionsChain(null);
            }
            delayedCallback(
              () =>
                setMD((s) => [
                  ...s,
                  {
                    id: 0,
                    message: lang("an_agent_will_support_you"),
                    user_id: null,
                    is_agent: "1",
                    is_bot: "0",
                    is_auto: "1",
                    ai_active: activeAi ? "1" : "0",
                    datetime: generateDateInTimeZone(),
                    order: 0,
                    weekday_int: "1",
                    no_trigger_checking_answer: true,
                  },
                ]),
              1
            );
          }

          if (phaseToGo?.action) {
            setInvokedForm(`${phaseToGo?.action.replace("wp/", "")}`);
            return;
          }

          delayedCallback(
            () =>
              setMD((s) => [
                ...s,
                {
                  id: 0,
                  message: phaseToGo?.rich_message ?? "",
                  user_id: null,
                  is_agent: "1",
                  is_bot: "0",
                  is_auto: "1",
                  ai_active: activeAi ? "1" : "0",
                  datetime: generateDateInTimeZone(),
                  order: 0,
                  weekday_int: "1",
                  no_trigger_checking_answer: true,
                },
              ]),
            delayChain
          );
        }
      }
    }, [optionsChain, optionsChainAnswer]);

    React.useEffect(() => {
      if (typeof window !== "undefined" && flowiseChat) {
        localStorage.setItem(
          `${window.FLOW_AI[sufixGUID]}_EXTERNAL`,
          JSON.stringify({
            chatId: flowiseChat,
            chatHistory: messagesData?.map((m) => {
              let basicPyld = {
                message: m.message,
                type: m?.is_bot === "0" ? "userMessage" : "apiMessage",
              };
              if (m?.is_bot === "0") {
                basicPyld.fileUploads = [];
              }
              return basicPyld;
            }),
          })
        );
      }
    }, [messagesData]);

    React.useEffect(() => {
      let actualPhase = Number(window.localStorage.getItem("CHAINING_PHASE_" + sufixGUID));

      if (optionsChain && messagesData.length > 0 && actualPhase > 1) {
        const getLastAnswer = messagesData[messagesData.length - 1];

        if (getLastAnswer.no_trigger_checking_answer || !getLastAnswer.message) {
          return;
        }

        let getIdToGetAvailables = getLastAnswer.message?.split("-")[0].split("::")[1];

        let getUserOptionsAnswer = JSON.parse(getLastAnswer.message?.split("-")[1]?.split("::")[0])[0];

        let userAnswered = Object.entries(getUserOptionsAnswer).find((crc) => crc.some((cr) => cr === true))[0];

        setOptionsChainAnswer({
          id: getIdToGetAvailables,
          answer: userAnswered,
        });
      }
    }, [messagesData]);

    React.useEffect(() => {
      const conversationAlreadyStartedBefore = findLocalStorageValue("UNAUTH_CONV_TOKEN_CHANNEL_" + sufixGUID + "_" + selectedChannel);

      if (JSON.stringify(autoMessaging) !== "[]" && JSON.stringify(officeHours) !== "{}" && conversationData) {
        let newMsg = JSON.parse(conversationData?.messages_informations?.conversations_messagens ?? "[]");

        if (newMsg?.length === 0) {
          const conditionalMessaging = {
            option: (data) => data.option,
            message: (data) => data.message,
            welcome: (data) => data.message,
          };

          let bgPreview = " ";
          let headerPreview = "https://th.bing.com/th/id/R.ec2b0f17903e99d969e7b97956be2799?rik=EWDVzSZjXFzukQ&pid=ImgRaw&r=0";
          let msgPreview = "";
          if (customStyle) {
            bgPreview = domainBaseURL + "/files/" + customStyle?.header_background_image_value;
            headerPreview = domainBaseURL + "/files/" + customStyle?.brand_header_image_value;
          }

          let customToWorkOutsideHours = autoMessaging?.find((atMsg) => {
            if (
              (typeof atMsg?.type !== "undefined" && atMsg?.type === "form") ||
              atMsg?.type === "option" ||
              atMsg?.type === "optionv2" ||
              atMsg?.type === "welcome"
            ) {
              let triggerAndContent = JSON.parse(atMsg?.data ?? "{}");
              return triggerAndContent.disable_outside_office_hours === "both" || triggerAndContent.disable_outside_office_hours === "off";
            }
            return null;
          });

          let customToHideOutsideHours = autoMessaging?.find((atMsg) => {
            if (
              (typeof atMsg?.type !== "undefined" && atMsg?.type === "form") ||
              atMsg?.type === "option" ||
              atMsg?.type === "optionv2" ||
              atMsg?.type === "welcome"
            ) {
              let triggerAndContent = JSON.parse(atMsg?.data ?? "{}");
              return triggerAndContent.disable_outside_office_hours === "both" || triggerAndContent.disable_outside_office_hours === "on";
            }
            return null;
          });

          const parsedSettingsCustomWorkOutHours = JSON.parse(customToWorkOutsideHours?.data ?? "{}");

          const parsedSettingsCustomHideOutHours = JSON.parse(customToHideOutsideHours?.data ?? "{}");

          if (typeof customToWorkOutsideHours?.type !== "undefined" && customToWorkOutsideHours?.type === "form") {
            let filteredForm = formsData.find((fm) => fm.token === parsedSettingsCustomWorkOutHours.form);

            customToWorkOutsideHours.form_url = `form::[${filteredForm.link.replace("wp/", "")}]`;
          }

          if (typeof customToHideOutsideHours?.type !== "undefined" && customToHideOutsideHours?.type === "form") {
            let filteredForm = formsData.find((fm) => fm.token === parsedSettingsCustomHideOutHours.form);

            customToHideOutsideHours.form_url = `form::[${filteredForm.link.replace("wp/", "")}]`;
          }

          if (
            !isChatAvailable(
              officeHours?.data,
              new Date(formatDate(new Date(), officeHours?.timezone, new Date().getTimezoneOffset())),
              setIsUnavailableDueTime
            )
          ) {
            if (customToWorkOutsideHours) {
              if (typeof customToWorkOutsideHours?.type !== "undefined" && customToWorkOutsideHours?.type === "form") {
                setInvokedForm(customToWorkOutsideHours.form_url?.slice(7, -1));
                return;
              }

              if (typeof customToWorkOutsideHours?.type !== "undefined" && customToWorkOutsideHours?.type === "optionv2") {
                msgPreview = JSON.parse(customToWorkOutsideHours.data)?.chain?.flow[1]?.data?.questions?.join(" ") ?? lang("fallback_welcome_message_preview");
                setChatDataPreview(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`);
                window.parent.postMessage(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`, "*");
                setStartedChat(true);
                setMD((s) => [
                  ...s,
                  {
                    id: 0,
                    message: "CHAT_OPTIONV2",
                    user_id: null,
                    is_agent: "1",
                    is_bot: "0",
                    is_auto: "1",
                    ai_active: activeAi ? "1" : "0",
                    datetime: "",
                    order: 0,
                    weekday_int: "1",
                    flow: customToWorkOutsideHours.data,
                  },
                ]);
                return;
              }

              if (JSON.parse(customToWorkOutsideHours?.data)?.chain) {
                msgPreview =
                  JSON.parse(JSON.parse(JSON.parse(customToWorkOutsideHours.data)?.chain)[1][0]?.rich_message?.slice(3, -3))?.label ??
                  lang("fallback_welcome_message_preview");
                setChatDataPreview(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`);
                window.parent.postMessage(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`, "*");
                setOptionsChain(JSON.parse(customToWorkOutsideHours.data));
              }

              if (customToWorkOutsideHours?.type === "welcome") {
                msgPreview = JSON.parse(customToWorkOutsideHours.data)?.message ?? lang("fallback_welcome_message_preview");
                setChatDataPreview(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`);
                window.parent.postMessage(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`, "*");
              }

              delayedCallback(
                () =>
                  setMD((s) => [
                    ...s,
                    {
                      id: 0,
                      message: conditionalMessaging[customToWorkOutsideHours?.type](
                        customToWorkOutsideHours?.type === "option" || customToWorkOutsideHours?.type === "welcome"
                          ? JSON.parse(customToWorkOutsideHours.data)
                          : customToWorkOutsideHours
                      ),
                      user_id: null,
                      is_agent: "1",
                      is_bot: "0",
                      is_auto: "1",
                      ai_active: activeAi ? "1" : "0",
                      datetime: generateDateInTimeZone(),
                      order: 0,
                      weekday_int: "1",
                    },
                  ]),
                JSON.parse(customToWorkOutsideHours.data)?.delay
              );
            } else {
              if (activeAi) {
                return;
              }
              setMD((s) => [
                ...s,
                {
                  id: 0,
                  message: lang("chat_is_unavailable_now"),
                  user_id: null,
                  is_agent: "1",
                  is_bot: "0",
                  is_auto: "1",
                  ai_active: activeAi ? "1" : "0",
                  datetime: generateDateInTimeZone(),
                  order: 0,
                  weekday_int: "1",
                },
              ]);
            }

            if (parsedSettingsCustomWorkOutHours.trigger === "page") {
              setStartedChat(true);
            }
            return;
          }

          if (conversationAlreadyStartedBefore) {
            return;
          }

          if (customToHideOutsideHours) {
            if (parsedSettingsCustomHideOutHours.trigger === "page") {
              setStartedChat(true);
            }

            if (typeof customToHideOutsideHours?.type !== "undefined" && customToHideOutsideHours?.type === "form") {
              setInvokedForm(customToHideOutsideHours.form_url?.slice(7, -1));
              return;
            }

            if (typeof customToHideOutsideHours?.type !== "undefined" && customToHideOutsideHours?.type === "optionv2") {
              msgPreview = JSON.parse(customToWorkOutsideHours.data)?.chain?.flow[1]?.data?.questions?.join(" ") ?? lang("fallback_welcome_message_preview");
              setChatDataPreview(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`);
              window.parent.postMessage(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`, "*");
              setStartedChat(true);
              setMD((s) => [
                ...s,
                {
                  id: 0,
                  message: "CHAT_OPTIONV2",
                  user_id: null,
                  is_agent: "1",
                  is_bot: "0",
                  is_auto: "1",
                  ai_active: activeAi ? "1" : "0",
                  datetime: "",
                  order: 0,
                  weekday_int: "1",
                  flow: customToHideOutsideHours.data,
                },
              ]);
              return;
            }

            if (JSON.parse(customToHideOutsideHours?.data)?.chain) {
              msgPreview =
                JSON.parse(JSON.parse(JSON.parse(customToHideOutsideHours.data)?.chain)[1][0]?.rich_message?.slice(3, -3))?.label ??
                lang("fallback_welcome_message_preview");
              setChatDataPreview(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`);
              window.parent.postMessage(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`, "*");
              setOptionsChain(JSON.parse(customToHideOutsideHours.data));
            }

            if (customToHideOutsideHours?.type === "welcome") {
              msgPreview = JSON.parse(customToHideOutsideHours.data)?.message ?? lang("fallback_welcome_message_preview");
              setChatDataPreview(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`);
              window.parent.postMessage(`SHOW_PREVIEW_${sufixGUID}#${msgPreview}#${bgPreview}#${headerPreview}`, "*");
            }

            delayedCallback(
              () =>
                setMD((s) => [
                  ...s,
                  {
                    id: 0,
                    message: conditionalMessaging[customToHideOutsideHours?.type](
                      customToHideOutsideHours?.type === "option" || customToHideOutsideHours?.type === "welcome"
                        ? JSON.parse(customToHideOutsideHours.data)
                        : customToHideOutsideHours
                    ),
                    user_id: null,
                    is_agent: "1",
                    is_bot: "0",
                    is_auto: "1",
                    ai_active: activeAi ? "1" : "0",
                    datetime: generateDateInTimeZone(),
                    order: 0,
                    weekday_int: "1",
                  },
                ]),
              JSON.parse(customToHideOutsideHours.data)?.delay
            );
          }
        }
      }
    }, [autoMessaging]);

    React.useEffect(() => {
      if (typeof window !== "undefined" && JSON.stringify(conversationData) !== "{}") {
        if (
          !window.localStorage.getItem("UNAUTH_CONV_TOKEN_CHANNEL_" + sufixGUID + "_" + chatChannelId) &&
          !window.localStorage.getItem("UNAUTH_CONV_TOVR_CHANNEL_" + sufixGUID + "_" + chatChannelId)
        ) {
          window.localStorage.setItem("UNAUTH_CONV_TOKEN_CHANNEL_" + sufixGUID + "_" + chatChannelId, conversationData.token);
          window.localStorage.setItem("UNAUTH_CONV_TOVR_CHANNEL_" + sufixGUID + "_" + chatChannelId, String(new Date().getTime()));
        }
      }
    }, [conversationData, window]);

    const fetchChatConversationData = async (conversationToken) => {
      try {
        const { data } = await apiWebsite.get("/chat/list_conversations_token?uuid=" + tenantId + "&token=" + conversationToken);
        if (data && data?.conversations?.id) {
          setCD(data?.conversations);
          let newMsg = JSON.parse(data?.conversations?.messages_informations?.conversations_messagens ?? "[]");
          setMD((s) => [
            ...newMsg?.filter((mes) => !mes.message?.startsWith("option::") || !mes.message?.startsWith("form::") || !mes.message?.startsWith("end::")),
          ]);
        }
      } catch (e) {
        console.error(e);
      }
    };

    React.useEffect(() => {
      setCustomStyle(customs);
      setOfficeHours(office);
      setAutoMessaging(autoMessageData);
    }, [office, customs, autoMessageData]);

    React.useEffect(() => {
      const THREE_HOURS_IN_MS = 10800000;
      setSCHA(chatChannelId);
      if (typeof window !== "undefined") {
        const checkTimeDiff = new Date().getTime() - Number(window.localStorage.getItem("UNAUTH_CONV_TOVR_CHANNEL_" + sufixGUID + "_" + chatChannelId));
        if (checkTimeDiff < THREE_HOURS_IN_MS) {
          console.log(">>>>>> Fetch actual conversation due to time not timeover");
          fetchChatConversationData(window.localStorage.getItem("UNAUTH_CONV_TOKEN_CHANNEL_" + sufixGUID + "_" + chatChannelId));
          setStartedChat(true);
        } else {
          window.localStorage.removeItem("UNAUTH_CONV_TOKEN_CHANNEL_" + sufixGUID + "_" + chatChannelId);
          window.localStorage.removeItem("UNAUTH_CONV_TOVR_CHANNEL_" + sufixGUID + "_" + chatChannelId);
        }
      }
      pusherInit();
      //pusherAuth();
    }, []);

    React.useEffect(() => {
      if (selectedFile !== null) {
        saveAndEmitMessage(true, "SEND_IMAGE");
      }
    }, [selectedFile]);

    React.useEffect(() => {
      if (conversationData?.token) {
        let pvCh = pusherInstance.subscribe(`${selectedChannel}@${conversationData.token}`);
        pvCh.bind("new-message-private", function (data) {
          let newMsg = JSON.parse(data?.conversation?.messages_informations?.conversations_messagens ?? "[]");
          setMD((s) => [...newMsg]);
          if (newMsg[newMsg?.length - 1]?.message?.startsWith("form::[")) {
            const formToInvoke = newMsg[newMsg?.length - 1]?.message?.slice(7, -1);
            setInvokedForm(formToInvoke);
          }
          if (channelData?.chat_auto_notifications_token) {
            notificationSound.play();
          }
          saveInLocalHistory(data?.conversation);
        });
        pvCh.bind("transfered", function (data) {
          setMD((s) => [
            ...s,
            {
              message: lang("you_are_transfered"),
              user_id: null,
              is_agent: "1",
              is_bot: "0",
              is_auto: "1",
              datetime: generateDateInTimeZone(),
              order: 0,
              weekday_int: "1",
            },
          ]);
          setSCHA(data.to);
        });
        pvCh.bind("end", function (data) {
          window.localStorage.removeItem("UNAUTH_CONV_TOKEN_CHANNEL_" + sufixGUID + "_" + data.channel);
          window.localStorage.removeItem("UNAUTH_CONV_TOVR_CHANNEL_" + sufixGUID + "_" + data.channel);
          window.location.reload();
        });
        setPusherPrivate(pvCh);
      }
    }, [conversationData]);

    React.useEffect(() => {
      if (pusherInstance !== null) {
        if (chatSession) {
          let newCv = pusherInstance?.subscribe(`${chatChannelId}@new`);
          newCv.bind("new-conversation", function (data) {
            if (Number(data?.userId) === Number(chatSession?.id)) {
              setCD(data?.conversation);
              let newMsg = JSON.parse(data?.conversation?.messages_informations?.conversations_messagens ?? "[]");
              setMD((s) => [...newMsg]);
              if (channelData?.chat_auto_notifications_token) {
                notificationSound.play();
              }
            }
          });
        }
        const channelOn = pusherInstance.subscribe("cache-" + chatChannelId);
        channelOn.bind("update", function (data) {
          console.log(data);
        });
      }
    }, [pusherInstance]);

    const openEmojis = () => {
      setSelectEmojis((s) => !s);
    };

    const EmojiPicker = ({ setText }) => {
      const ref = React.useRef(null);

      React.useEffect(() => {
        ref.current?.addEventListener("emoji-click", (event) => {
          setText((s) => s.concat(event.detail.unicode));
        });
        ref.current.skinToneEmoji = "👍";
        ref.current.style.width = "100%";
        ref.current.style.height = "auto";
        ref.current.className = "light";
      }, []);

      return React.createElement("emoji-picker", { ref });
    };

    const pressEnter = (event) => {
      if (event.key === "Enter") {
        onSubmit(event);
      }
    };

    const disableAi = () => {
      setHideAudioCapture(true);
      saveAndEmitMessage(false, `call@agent::["${lang("type_what_you_need_an_agent_will_reply_soon")}"]`);
    };

    const endConversation = () => {
      if (typeof window !== "undefined") {
        let copyConvData = { ...conversationData };
        copyConvData.messages_informations.conversations_messagens = JSON.stringify(messagesData);
        saveInLocalHistory(copyConvData);
        if (window.localStorage.getItem("CHAINING_PHASE_" + sufixGUID)) {
          window.localStorage.removeItem("CHAINING_PHASE_" + sufixGUID);
        }

        window.localStorage.removeItem("UNAUTH_CONV_TOKEN_CHANNEL_" + sufixGUID + "_" + chatChannelId);
        window.localStorage.removeItem("UNAUTH_CONV_TOVR_CHANNEL_" + sufixGUID + "_" + chatChannelId);
      }

      setCD({});
      setMD([]);
      setTextMsg("");
      setStartedChat(false);
      setSelectedFile(null);
      setSelectEmojis(false);
      setOptionsChain(null);
      setActiveAi(null);
      setAudioChunks([]);
      setOptionsChainAnswer({
        id: 0,
        answer: null,
      });
      setFormData({
        name: "",
        phoneNumber: "",
        email: "",
      });
      reloadChatConversation();
    };

    const toggleOldConversations = () => {
      setShowOldConversations(!showOldConversations);
    };

    React.useEffect(() => {
      if (messagesData?.find((ms) => ms?.ai_active === "0" && ms?.is_auto !== "1") || messagesData?.find((ms) => ms?.is_agent === "1" && ms?.is_auto !== "1")) {
        setHideAudioCapture(true);
        setActiveAi(null);
      }
    }, [messagesData]);

    return (
      officeHours?.id &&
      channelData?.id && (
        <Container
          lang={lang}
          customStyle={customStyle}
          activeAi={activeAi}
          channelData={channelData}
          disableAi={disableAi}
          endConversation={endConversation}
          startedChat={startedChat}
          showOldConversations={showOldConversations}
          toggleOldConversations={toggleOldConversations}
          oldConversations={chatOldConversations}
          messagesData={messagesData}
          openImageModal={openImageModal}
          optionsChain={optionsChain}
          selectedChannel={selectedChannel}
          showFormInMessage={showFormInMessage}
          chatSession={chatSession}
          isChatAvailableNow={!isUnavailableDueTime}
          showListChatIcon={channelData?.can_see_conversation_history && Number(channelData?.can_see_conversation_history)}
        >
          {(() => {
            if (!startedChat && channelData.access !== null && channelData.access === "login" && !chatSession?.id) {
              return (
                <ChatWelcomeScreen
                  activeAi={activeAi}
                  channelData={channelData}
                  disableAi={disableAi}
                  lang={lang}
                  customStyle={customStyle}
                  startedChat={startedChat}
                >
                  <div className="ebsss-chat-initial-welcome">
                    <small className="ebsss-chat-initial-terms">{lang("you_are_accepting_our_terms_when_chat")}</small>
                    <div className="ebsss-chat-initial-welcome-message">
                      <div className="ebsss-chat-initial-hover-container-start">
                        <a href="/auth/sign-in">
                          <div className="ebsss-chat-initial-start-chat-btn">
                            <span className="ebsss-chat-initial-title">{lang("please_auth")}</span>
                            <span className="subtitle">{lang("you_need_to_be_authed")}</span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </ChatWelcomeScreen>
              );
            }
          })()}
          {(() => {
            if (!startedChat && channelData.access !== null && channelData.access === "user_data") {
              return (
                <ChatArea>
                  <div
                    style={Object.assign(
                      {},
                      {
                        margin: 10,
                        paddingTop: 30,
                        flexDirection: "row",
                        display: "flex",
                        justifyContent: "space-between",
                        borderRadius: 10,
                        background: `url(${domainBaseURL + "/files/" + customStyle.header_background_image_value})`,
                        backgroundSize: "cover",
                      }
                    )}
                  >
                    <div style={Object.assign({}, { marginLeft: 15 })}>
                      <ChatElementHeader
                        title={customStyle.header_title}
                        description={customStyle.header_message}
                        image={
                          customStyle?.brand_header_image_value
                            ? domainBaseURL + "/files/" + customStyle.brand_header_image_value
                            : "https://th.bing.com/th/id/R.ec2b0f17903e99d969e7b97956be2799?rik=EWDVzSZjXFzukQ&pid=ImgRaw&r=0"
                        }
                      />
                    </div>
                    <div style={Object.assign({}, { marginRight: 25, display: "flex" })}></div>
                  </div>
                  <IdentifyUser
                    lang={lang}
                    setFormData={setFormData}
                    formData={formData}
                    setStartedChat={setStartedChat}
                    saveAndEmitMessage={saveAndEmitMessage}
                  />
                </ChatArea>
              );
            }
          })()}
          {(() => {
            if (!startedChat && (channelData.access === null || channelData.access === "open" || (channelData.access === "login" && chatSession?.id))) {
              return isChatAvailable(
                officeHours?.data,
                new Date(formatDate(new Date(), officeHours?.timezone, new Date().getTimezoneOffset())),
                setIsUnavailableDueTime
              ) ? (
                <ChatWelcomeScreen
                  activeAi={activeAi}
                  channelData={channelData}
                  disableAi={disableAi}
                  endConversation={endConversation}
                  lang={lang}
                  customStyle={customStyle}
                  startedChat={startedChat}
                >
                  <div className="ebsss-chat-initial-welcome">
                    <small className="ebsss-chat-initial-terms">{lang("you_are_accepting_our_terms_when_chat")}</small>
                    <div className="ebsss-chat-initial-welcome-message">
                      {Number(channelData?.only_chatbot) === 1 ? (
                        <></>
                      ) : (
                        <div
                          className="ebsss-chat-initial-hover-container-start"
                          style={Object.assign(
                            {},
                            {
                              cursor: employeesNow?.length > 0 ? "pointer" : "not-allowed",
                            }
                          )}
                          onClick={() => {
                            if (employeesNow?.length > 0) {
                              setActiveAi(null);
                              setStartedChat(true);
                            }
                          }}
                        >
                          <div className="ebsss-chat-initial-start-chat-btn">
                            <span className="ebsss-chat-initial-title">{lang("start_chat")}</span>
                            <span className="subtitle">{employeesNow?.length === 0 ? lang("no_agents_now") : lang("start_chat_subtitle")}</span>
                          </div>
                          {employeesNow?.length > 0 ? (
                            employeesNow?.map((empNow, empI) => {
                              return empNow?.avatar && empNow?.avatar?.length > 0 ? (
                                <img
                                  className="ebsss-chat-initial-chat-icon-container"
                                  width="100%"
                                  height="100%"
                                  src={domainBaseURL + "/files/" + empNow?.avatar}
                                  alt="Employee pic"
                                />
                              ) : (
                                <div
                                  style={{
                                    backgroundColor: "#f0ca4d",
                                    width: 35,
                                    height: 35,
                                    borderRadius: 500,
                                    alignItems: "center",
                                    display: "flex",
                                    justifyContent: "center",
                                    flexDirection: "row",
                                  }}
                                >
                                  <span>{empNow?.first_name ? empNow?.first_name[0]?.toUpperCase() : ""}</span>
                                  <span>{empNow?.last_name ? empNow?.last_name[0]?.toUpperCase() : ""}</span>
                                </div>
                              );
                            })
                          ) : (
                            <div
                              style={{
                                backgroundColor: "#e9e9e9",
                                width: 35,
                                height: 35,
                                borderRadius: 500,
                                alignItems: "center",
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "row",
                              }}
                            >
                              <NoAgentIcon />
                            </div>
                          )}
                        </div>
                      )}
                      {activeAi ? (
                        <div className="ebsss-chat-initial-hover-container-start" onClick={() => setStartedChat(true)}>
                          <div className="ebsss-chat-initial-start-chat-btn">
                            <span className="ebsss-chat-initial-title">{lang("start_chat_ai")}</span>
                            <span className="subtitle">{lang("start_chat_ai_subtitle")}</span>
                          </div>
                          <div className="ebsss-chat-initial-chat-icon-container">
                            <RobotIcon />
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </ChatWelcomeScreen>
              ) : JSON.stringify(autoMessageData) === "[]" ? (
                <ChatWelcomeScreen
                  activeAi={activeAi}
                  channelData={channelData}
                  disableAi={disableAi}
                  endConversation={endConversation}
                  lang={lang}
                  customStyle={customStyle}
                  startedChat={startedChat}
                >
                  <div className="ebsss-chat-initial-welcome">
                    <small className="ebsss-chat-initial-terms">{lang("you_are_accepting_our_terms_when_chat")}</small>
                    <div className="ebsss-chat-initial-welcome-message">
                      <div className="ebsss-chat-initial-hover-container-start">
                        <div className="ebsss-chat-initial-start-chat-btn">
                          <span>{lang("unavailable")}</span>
                          <span className="subtitle">{lang("unavailable_subtitle")}</span>
                        </div>
                      </div>
                      {activeAi ? (
                        <div className="ebsss-chat-initial-hover-container-start" onClick={() => setStartedChat(true)}>
                          <div className="ebsss-chat-initial-start-chat-btn">
                            <span className="ebsss-chat-initial-title">{lang("start_chat_ai")}</span>
                            <span className="subtitle">{lang("start_chat_ai_subtitle")}</span>
                          </div>
                          <div className="ebsss-chat-initial-chat-icon-container">
                            <div>
                              <RobotIcon />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </ChatWelcomeScreen>
              ) : (
                <ChatWelcomeScreen
                  activeAi={activeAi}
                  channelData={channelData}
                  disableAi={disableAi}
                  endConversation={endConversation}
                  lang={lang}
                  customStyle={customStyle}
                  startedChat={startedChat}
                >
                  <div className="ebsss-chat-initial-welcome">
                    <small className="ebsss-chat-initial-terms">{lang("you_are_accepting_our_terms_when_chat")}</small>
                    <div className="ebsss-chat-initial-welcome-message">
                      <div className="ebsss-chat-initial-hover-container-start">
                        <div className="ebsss-chat-initial-start-chat-btn">
                          <span>{lang("unavailable")}</span>
                          <span className="subtitle">{lang("unavailable_subtitle")}</span>
                        </div>
                      </div>
                      {activeAi ? (
                        <div className="ebsss-chat-initial-hover-container-start" onClick={() => setStartedChat(true)}>
                          <div className="ebsss-chat-initial-start-chat-btn">
                            <span className="ebsss-chat-initial-title">{lang("start_chat_ai")}</span>
                            <span className="subtitle">{lang("start_chat_ai_subtitle")}</span>
                          </div>
                          <div className="ebsss-chat-initial-chat-icon-container">
                            <div>
                              <RobotIcon />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </ChatWelcomeScreen>
              );
            }
          })()}
          {(() => {
            if (startedChat) {
              return (
                <ChatArea>
                  <div
                    style={Object.assign(
                      {},
                      {
                        paddingTop: 30,
                        flexDirection: "row",
                        display: "flex",
                        justifyContent: "space-between",
                        borderRadius: 10,
                        background: `url(${domainBaseURL + "/files/" + customStyle.header_background_image_value})`,
                        marginRight: 5,
                        backgroundSize: "cover",
                      }
                    )}
                  >
                    <div style={Object.assign({}, { marginLeft: 15 })}>
                      <ChatElementHeader
                        title={customStyle.header_title}
                        description={customStyle.header_message}
                        image={
                          customStyle?.brand_header_image_value
                            ? domainBaseURL + "/files/" + customStyle.brand_header_image_value
                            : "https://th.bing.com/th/id/R.ec2b0f17903e99d969e7b97956be2799?rik=EWDVzSZjXFzukQ&pid=ImgRaw&r=0"
                        }
                      />
                    </div>
                  </div>
                  {selectEmojis ? (
                    <ChatAreaWrapper
                      messagesData={[]}
                      startedChat={startedChat}
                      activeAi={activeAi}
                      channelData={channelData}
                      isChatAvailableNow={!isUnavailableDueTime}
                      disableAi={disableAi}
                      lang={lang}
                      backgroundImage={domainBaseURL.replace("://", "://gestor.") + `/images/chat_${customStyle?.chat_background_texture}.png`}
                    >
                      <EmojiPicker
                        setText={setTextMsg}
                        style={Object.assign(
                          {},
                          {
                            width: "100%",
                            height: "auto",
                          }
                        )}
                      />
                    </ChatAreaWrapper>
                  ) : (
                    <ChatAreaWrapper
                      typeEffect={typeEffect}
                      messagesData={messagesData}
                      startedChat={startedChat}
                      activeAi={activeAi}
                      channelData={channelData}
                      isChatAvailableNow={!isUnavailableDueTime}
                      disableAi={disableAi}
                      lang={lang}
                      backgroundImage={domainBaseURL.replace("://", "://gestor.") + `/images/chat_${customStyle?.chat_background_texture}.png`}
                    >
                      {showFormInMessage ? (
                        <div className="ebsss-widget-chat-msg" style={Object.assign({}, { width: 350 })} key={"form"}>
                          <div className="ebsss-widget-chat-msg-profile-form">
                            <img
                              className="ebsss-widget-chat-msg-img"
                              src="https://st4.depositphotos.com/4329009/19956/v/450/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
                              alt="Profile pic"
                            />
                            <div className="ebsss-widget-chat-msg-date"></div>
                          </div>
                          <FormComponent src={showFormInMessage} lang={lang} />
                        </div>
                      ) : (
                        messagesData
                          ?.filter((mes) => !mes.message?.startsWith("option::"))
                          ?.filter((mes) => !mes.message?.startsWith("form::"))
                          ?.filter((mes) => !mes.message?.startsWith("end::"))
                          ?.filter((mes) => !mes.message?.startsWith("optionv2::"))
                          ?.filter((mes) => !mes.message?.startsWith("optionv2@ai::"))
                          ?.filter((mes) => !mes.message?.startsWith("speech@ai"))
                          ?.filter((mes) => !mes.message?.startsWith("call@agent::"))
                          ?.filter((mes) => !mes.message?.startsWith("new@conversation"))
                          ?.filter((mes) => mes.message)
                          ?.map((message) =>
                            message?.is_agent === "0" && message?.is_bot === "0" ? (
                              <MessageSent
                                lang={lang}
                                customStyle={customStyle}
                                messagesData={messagesData}
                                message={message}
                                bg={customStyle?.primary_color}
                                openImageModal={openImageModal}
                                saveAndEmitMessage={saveAndEmitMessage}
                                userImage={
                                  chatSession && chatSession?.profile?.avatar ? window.location.origin + "/files/" + chatSession?.profile?.avatar : null
                                }
                              />
                            ) : (
                              <MessageReceived
                                lang={lang}
                                conversationToken={conversationData.token}
                                channelToken={selectedChannel}
                                optionsChain={optionsChain}
                                customStyle={customStyle}
                                showFormInMessage={showFormInMessage}
                                messagesData={messagesData}
                                message={message}
                                bg={customStyle?.secondary_color}
                                openImageModal={openImageModal}
                                saveAndEmitMessage={saveAndEmitMessage}
                              />
                            )
                          )
                      )}
                      {typeEffect ? (
                        <div className="ebsss-widget-chat-msg">
                          <div className="ebsss-widget-chat-msg-profile-form">
                            <img
                              className="ebsss-widget-chat-msg-img"
                              src="https://st4.depositphotos.com/4329009/19956/v/450/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
                              alt="Profile pic"
                            />
                            <div className="ebsss-widget-chat-msg-date"></div>
                          </div>
                          <TypingAnimationIcon />
                        </div>
                      ) : (
                        <></>
                      )}
                      {mockSentMessage ? (
                        <div className="ebsss-widget-chat-msg ebsss-widget-owner">
                          <div className="ebsss-widget-chat-msg-profile">
                            <div className="ebsss-widget-chat-msg-date">
                              <span>
                                <LoadingIcon />
                              </span>
                            </div>
                          </div>
                          <div className="ebsss-widget-chat-msg-content">
                            <div
                              className="ebsss-widget-chat-msg-text"
                              ref={(el) => {
                                if (customStyle?.primary_color) {
                                  if (el) {
                                    el.style.backgroundColor = customStyle?.primary_color;
                                  }
                                }
                              }}
                              style={Object.assign({}, { color: "#000" })}
                            >
                              {renderBreakLines(mockSentMessage)}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </ChatAreaWrapper>
                  )}
                  {!showFormInMessage ? (
                    <ChatAreaFooter
                      handleDeleteRecording={handleDeleteRecording}
                      handleStartRecording={handleStartRecording}
                      handleStopRecording={handleStopRecording}
                      handlePlayRecording={handlePlayRecording}
                      audioChunks={audioChunks}
                      recording={recording}
                      lang={lang}
                      pressEnter={pressEnter}
                      openEmojis={openEmojis}
                      onChange={onChange}
                      onSubmit={onSubmit}
                      selectedFile={selectedFile}
                      setSelectedFile={setSelectedFile}
                      canUploadFiles={!channelData?.disable_uploads}
                      valuetextMsg={textMsg}
                      hideAudioCapture={hideAudioCapture}
                      activeAi={activeAi}
                      channelData={channelData}
                    />
                  ) : (
                    <></>
                  )}
                </ChatArea>
              );
            }
          })()}
        </Container>
      )
    );
  };

  const App = () => {
    const [channelData, setChannelData] = React.useState({});
    const [autoMessageData, setAutoMessageData] = React.useState(null);
    const [officeHours, setOfficeHours] = React.useState({});
    const [customStyle, setCustomStyle] = React.useState({});
    const [formsData, setFormsData] = React.useState([]);
    const [isUnavailableDueTime, setIsUnavailableDueTime] = React.useState(false);
    const [onlineAgents, setOnlineAgents] = React.useState(true);
    const [invokedForm, setInvokedForm] = React.useState("");
    const [forceStartedChat, setForceStartedChat] = React.useState(false);
    const [translations, setTranslations] = React.useState({});
    const [activeAi, setActiveAi] = React.useState(null);
    const [flowAi, setFlowAi] = React.useState(null);
    const [flowiseChat, setFlowiseChat] = React.useState("");
    const [chatSession, setChatSession] = React.useState(null);
    const [chatOldConversations, setChatOldConversations] = React.useState([]);
    const [employeesNow, setEmployeesNow] = React.useState([]);

    const lang = (key) => {
      return translations["chat_v2." + key] ?? `_${key}_`;
    };

    const ebsssLayout: Layout = useSelector((state) => state[ReduxDataKey.LAYOUT]);

    const fetchChannelInformation = async (code = "", goAhead = false) => {
      try {
        await apiWebsite.get(`/chat/external_view?channel=${chatChannelId}&uuid=${tenantId}&code=${ebsssLayout?.activeLanguage}`).then(async (res) => {
          console.log("RES CHAT FETCHER OK: ", res);
          if (res) {
            if (!res?.language?.actual_lang && !goAhead) {
              await fetchChannelInformation(document.querySelector("[lang]")?.lang?.slice(0, 2) ?? "pt", true);
              return;
            }
            if (!chatDataSetter) {
              setChatDataSetter(res);
            }
            setTranslations(res?.translation);
            setFormsData(res?.forms);
            setChannelData(res?.config[0]);
            setChatSession(res?.chat_session);
            setChatOldConversations(res?.chat_history ?? []);
            if (!res?.chat_session) {
              let actualLocalHistory = findLocalStorageValue("HISTORY_CHAT_CONVERSATION_" + sufixGUID + "_" + res?.config[0]?.token);
              if (actualLocalHistory) {
                setChatOldConversations(JSON.parse(actualLocalHistory));
              }
            }
            if (res?.employees_now) {
              setEmployeesNow(res?.employees_now);
            }
            if (res?.office) {
              setOfficeHours(res?.office);
            }
            if (res?.ai) {
              if (res?.ai?.type === "nlp") {
                setFlowAi(JSON.parse(JSON.parse(res?.ai?.data).flow));
                if (typeof window !== "undefined") {
                  window.FLOW_AI = { [sufixGUID]: JSON.parse(JSON.parse(res?.ai?.data)?.flow) };
                  window.KNOWLEDGE_CATEGORY = res?.ai?.knowledge_categories;
                }
                const { containerBootstrap, Nlp, LangPt, fs } = window.nlpjs;
                const engageNLPjsNeuralNetwork = async () => {
                  const container = await containerBootstrap();
                  container.register("fs", fs);
                  container.use(Nlp);
                  container.use(LangPt);
                  const nlp = container.get("nlp");
                  nlp.settings.autoSave = false;
                  nlp.addLanguage("pt");
                  await nlp.addCorpus(domainBaseURL + "/files/" + JSON.parse(res?.ai?.data).corpus);
                  await nlp.train();
                  setActiveAi({ process: (mg) => nlp.process("pt", mg) });
                };

                engageNLPjsNeuralNetwork();
              } else if (res?.ai?.type === "flowise") {
                if (typeof window !== "undefined") {
                  window.FLOW_AI = { [sufixGUID]: JSON.parse(res?.ai?.data)?.flowise_token };
                }
                setFlowiseChat(crypto.randomUUID());
                const apiFlowise = (mg, file = null) =>
                  new AxiosHandler(`${apiFlowiseBaseURL}/api/v1/prediction`)
                    .post(
                      window.FLOW_AI[sufixGUID],
                      Object.assign(
                        {
                          question: file ? "" : mg,
                          history: JSON.parse(localStorage.getItem(`${window.FLOW_AI[sufixGUID]}_EXTERNAL`))?.chatHistory,
                          chatId: JSON.parse(localStorage.getItem(`${window.FLOW_AI[sufixGUID]}_EXTERNAL`))?.chatId,
                          socketIOClientId: "zJ40N0-SzOzxn5fBAABX",
                        },
                        file ? { uploads: [file] } : {}
                      )
                    )
                    .then((r) => {
                      let getActual = JSON.parse(localStorage.getItem(`${window.FLOW_AI[sufixGUID]}_EXTERNAL`));
                      if (!getActual.chatId) {
                        localStorage.setItem(`${window.FLOW_AI[sufixGUID]}_EXTERNAL`, JSON.stringify({ ...getActual, chatId: r.chatId }));
                      }
                      return { answer: r.text };
                    });
                setActiveAi({ process: apiFlowise });
                if (Number(res?.config[0]?.start_with_chatbot) === 1) {
                  setForceStartedChat(true);
                }
              }
            }
            if (res?.styles) {
              let customDesignData = JSON.parse(res?.styles?.data);
              if (!res?.language?.actual_lang) {
                setCustomStyle(customDesignData);
                return;
              }
              let actualTranslateData = res?.styles?.translations?.find((trans) => trans.code === res?.language?.actual_lang);
              if (actualTranslateData) {
                customDesignData.header_title = actualTranslateData.header_title;
                customDesignData.header_message = actualTranslateData.header_message;
              }
              setCustomStyle(customDesignData);
            }
            if (res?.auto_message) {
              setAutoMessageData(
                res?.auto_message?.map((am) => {
                  if (!res?.language?.actual_lang) {
                    return am;
                  }
                  let actualTranslateData = am?.translations?.find((trans) => trans.code === res?.language?.actual_lang);
                  if (actualTranslateData) {
                    return { ...am, data: JSON.stringify({ ...JSON.parse(am?.data), message: actualTranslateData?.message }) };
                  }
                  return am;
                })
              );
            }
          }
        });
      } catch (error) {
        console.log("RES CHAT FETCHER ERROR: ", error);
        if (error?.request?.status === 404) {
          localStorage.setItem("NOT_FOUND_CHAT_" + sufixGUID, "true");
          document.querySelector("#chat-button-" + sufixGUID)?.remove();
          return;
        }
      }
    };

    React.useEffect(() => {
      window.localStorage.removeItem("CHAINING_PHASE_" + sufixGUID);
      fetchChannelInformation();
    }, []);

    React.useEffect(() => {
      if (typeof window !== "undefined" && JSON.stringify(customStyle) !== "{}") {
        if (!!customStyle?.chat_icon) {
          window.parent.postMessage(`CHAT_ICON_${sufixGUID}#${customStyle?.chat_icon}`, "*");
        }
      }
    }, [customStyle]);

    React.useEffect(() => {
      if (typeof window !== "undefined" && JSON.stringify(customStyle) !== "{}") {
        if (customStyle.chat_position === "left") {
          const chatButtonContainer = window.parent.document.querySelector("#chat-button-container-" + sufixGUID);
          const chatBoxContainer = window.parent.document.querySelector("#chat-box-" + sufixGUID);
          if (chatButtonContainer) {
            chatButtonContainer.style.right = "";
            chatButtonContainer.style.left = "20px";
            chatButtonContainer.style.flexDirection = "row-reverse";
          }
          if (chatBoxContainer) {
            chatBoxContainer.style.right = "";
            chatBoxContainer.style.left = "20px";
          }
        }
      }
    }, [customStyle]);

    React.useEffect(() => {
      const chatButton = document.getElementById("chat-button-" + sufixGUID);
      const chatBox = document.getElementById("chat-box-" + sufixGUID);
      const logoImage = document.getElementById("logo-image-" + sufixGUID);

      if (typeof window !== "undefined" && autoMessageData && chatButton && chatBox && logoImage) {
        if (channelData?.id && JSON.stringify(officeHours) !== "{}") {
          const chatAvailable = isChatAvailable(officeHours?.data, new Date(formatDate(new Date(), officeHours?.timezone, new Date().getTimezoneOffset())));

          let triggerAndContent = JSON.parse(autoMessageData[0] ? autoMessageData[0]?.data : "{}");
          if (JSON.stringify(triggerAndContent) !== "{}") {
            if (triggerAndContent?.disable_outside_office_hours === "both" || triggerAndContent?.disable_outside_office_hours === "off") {
              if (typeof window !== undefined) {
                window.localStorage.setItem("OPENED_BY_SCRIPT", "1");
                if (chatButton) chatButton.click();
                return;
              }
            }
          }

          if (
            (channelData?.hide_out_office_hours === 1 && !chatAvailable) ||
            (channelData?.hide_if_no_agent_online === 1 &&
              employeesNow?.length === 0 &&
              !activeAi &&
              (!autoMessageData[0] || triggerAndContent?.disable_outside_office_hours === "on"))
          ) {
            if (chatButton) chatButton.remove();
            if (chatBox) chatBox.remove();
            if (logoImage) logoImage.remove();
            return;
          }
        }
      }
    }, [window, officeHours, customStyle, channelData, autoMessageData, employeesNow]);

    React.useEffect(() => {
      if (typeof window !== undefined) {
        window?.addEventListener("message", (event) => {
          if (event.data === "CLOSE_FORM") {
            setInvokedForm("");
            setForceStartedChat(true);
          }
        });
      }
    }, [window]);

    const containerStyle = {
      background: `url(${domainBaseURL}/mockchat.png)`,
      backgroundSize: "cover",
      padding: "25px",
      borderRadius: "15px",
      overflow: "hidden",
      maxWidth: "100%",
      margin: "auto",
    };

    const divStyle = {
      paddingLeft: "25px",
      paddingRight: "25px",
      maxWidth: "400px",
      margin: "auto",
    };

    const reloadChatConversation = () => {
      if (!window.location.href.includes("/v2")) {
        document.querySelector(['[id^="close-chat-button"]']).style.display = "none";
        document.querySelector(['[id^="alternative-icon"]']).style.display = "block";
      }
      window.localStorage.removeItem("CHAINING_PHASE_" + sufixGUID);
      setAutoMessageData([]);
      fetchChannelInformation();
    };

    return officeHours?.id && channelData.id ? (
      !invokedForm ? (
        <Chat
          lang={lang}
          flowAi={flowAi}
          flowiseChat={flowiseChat}
          activeAi={activeAi}
          setActiveAi={setActiveAi}
          office={officeHours}
          formsData={formsData}
          customs={customStyle}
          setInvokedForm={setInvokedForm}
          started={forceStartedChat}
          setIsUnavailableDueTime={setIsUnavailableDueTime}
          isUnavailableDueTime={isUnavailableDueTime}
          autoMessageData={autoMessageData ?? []}
          channelData={channelData}
          reloadChatConversation={reloadChatConversation}
          chatSession={chatSession}
          chatOldConversations={chatOldConversations}
          employeesNow={employeesNow}
        />
      ) : (
        <div style={widthValue === widthIframeValue ? containerStyle : {}}>
          <div style={Object.assign({}, divStyle)}>
            <FormComponent src={invokedForm} lang={lang} setInvokedForm={setInvokedForm} />
          </div>
        </div>
      )
    ) : (
      <></>
    );
  };

  return <App />;
}
